import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import styled from "styled-components";
import { Tab } from "../../Reusablecomponents/Tab";
import {
  Badge,
  Button,
  Col,
  Row,
  Avatar,
  Checkbox,
  Space,
  Popover,
  Menu,
  Dropdown,
  Tooltip,
  Form,
  Spin,
  message,
  Select,
  InputNumber,
  Input,
  Collapse,
  Upload,
  Modal,
  Card,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import { ReactComponent as CopyIcon } from "../../assets/images/Vector.svg";
import { ReactComponent as EditIcon } from "../../assets/images/Editicon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import { ReactComponent as Deleteunassigned } from "../../assets/images/deleteunassigned.svg";
import { ReactComponent as BulkDelete } from "../../assets/images/BulkDelete.svg";
import { ReactComponent as GeoDelete } from "../../assets/images/GeoDelete.svg";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import SortIcon from "../../assets/images/sort-svgrepo-com.svg";
import ImportIcon from "../../assets/images/download1.svg";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../Reusablecomponents/UIModal";
import NexusConsignDetails from "./nexusConsignDetails";
import { CALL_API } from "../../Common/api";
import {
  fetchNexusAssets,
  fetchNexusAssetInfo,
  fetchNexusFences,
} from "./nexusTrakingApi";
import { nexusEventLabel, NEXUS_EVENT_OPTIONS } from "./nexusEventLabels";
import {
  chargetype,
  PanTripTypeEnum,
  TripTypeEnum,
  DispatchType,
  FinishType,
  NexusFinishType,
  shipmentType,
  finishedtype,
} from "../../Common/constant";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  AIConsignmentDeliveryEvents,
  AIConsignmentCollectionEvents,
  AIConsignmentCombinedEvents,
} from "../../Common/constant";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import LocationPicker from "../../Reusablecomponents/LocationPicker/LocationPicker";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import axios from "axios";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useLocation, useParams } from "react-router-dom";
import { TRAKING_API_BASE } from "../../Common/traking";

const { RangePicker } = DatePicker;

// ─── Consignment import file ───────────────────────────────────────────
// One consignment per row. Names (consignor, consignee, vehicle, transporter and
// the type columns) are matched ignoring case; several consignees are separated
// by ";". Vehicle is optional: without one the consignment is created unassigned.
const IMPORT_HEADERS = [
  "Consignor",
  "Consignee",
  "Vehicle",
  "Transporter",
  "Charge Type",
  "Trip Type",
  "Shipment Type",
  "Dispatch Type",
  "Finish Type",
  "Pickup Date",
  "Drop Date",
  "Delivery Note",
  "Container No",
  "Trip Allowance",
];

const importNorm = (k) =>
  String(k || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const importCell = (row, header) => {
  const key = Object.keys(row).find(
    (k) => importNorm(k) === importNorm(header),
  );
  return key === undefined ? "" : row[key];
};

// DD/MM/YYYY [HH:mm], YYYY-MM-DD [HH:mm], an Excel serial number or a Date
const parseImportDate = (value) => {
  if (value === undefined || value === null || value === "") return null;
  if (value instanceof Date)
    return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === "number") {
    const d = XLSX.SSF.parse_date_code(value);
    return d ? new Date(d.y, d.m - 1, d.d, d.H || 0, d.M || 0) : null;
  }
  const text = String(value).trim();
  let m = text.match(
    /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})(?:[ T](\d{1,2}):(\d{2}))?/,
  );
  if (m)
    return new Date(
      Number(m[3]),
      Number(m[2]) - 1,
      Number(m[1]),
      Number(m[4] || 0),
      Number(m[5] || 0),
    );
  m = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
  if (m)
    return new Date(
      Number(m[1]),
      Number(m[2]) - 1,
      Number(m[3]),
      Number(m[4] || 0),
      Number(m[5] || 0),
    );
  const fallback = new Date(text);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
};

// "Delivery" / 1 -> the enum value, or undefined
const enumValue = (list, raw) => {
  if (raw === undefined || raw === null || String(raw).trim() === "")
    return undefined;
  const text = String(raw).trim().toLowerCase();
  const found = (list || []).find(
    (item) =>
      String(item.name).trim().toLowerCase() === text ||
      String(item.value) === text,
  );
  return found ? found.value : null; // null = given but unknown
};

const { Panel } = Collapse;
const { Option } = Select;

export const WrapperBox = styled.div`
  /* .ant-select {
    width: 100% !important;
  } */
  .selectdropdown_responsive {
    width: 100% !important;
  }
  .selectdropdown_responsive .custom-dropdown .ant-select-item-option-active {
    background-color: #f6ffed !important;
  }
  .selectdropdown_responsive .custom-dropdown .ant-select-item-option-selected {
    background-color: rgb(232, 255, 236) !important;
  }
  .selectdropdown_responsive .ant-select-selector {
    background-color: rgb(232, 255, 236) !important;
    border-radius: 8px !important;
    padding: 8px 12px !important;
  }
  .ant-select-arrow {
    color: #333 !important;
  }

  background-color: white;
  height: 60pz;
  padding: 9px 7px 3px 7px;
  border-radius: 8px;
  .consingment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5f6d8c;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
  }
  .FilterIcon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    // border-radius:50%;
    background-color: #ebf7ed !important;
    margin-left: 10px;
  }

  @media (max-width: 320px) {
    /* .consingment_container {
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #5f6d8c;
    } */
    /* .consingment_container_two {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    } */
    .ant-tabs-nav .ant-tabs-nav-list {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
  }
  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
  }
  .bulk_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: #e8ffec !important;
    color: #2c963d !important;
  }
  .ant-input {
    border-radius: 26px !important;
  }
  .Creating_Consignment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 10px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 15px 8px;
  }
  .ant-badge.ant-badge-status .ant-badge-status-dot {
    width: 12px;
    height: 12px;
  }
  .badg {
    padding: 6px;
  }

  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 7px 0px;
  }
  .flilter_five {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .container_for_assigned_unassigned {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
  }
  .consingment_container {
    /* margin: 16px 0px 10px 0px; */
  }
  /* @media (min-width: 320px) and (max-width: 426px) {
    .container_for_assigned_unassigned {
      display: block;
    }
    .consingment_container_two {
      display: block;
    }
    .consingment_container {
      margin-top: 25px !important;
    }
    .responsive_containerone {
      display: flex;
      gap: 09px;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 15px !important;
      justify-content:space-between;
    }
    .consingment_container {
      margin: 3px !important;
    }
    .datsource_length {
      margin-top: 2px !important;
    }
  } */

  @media (max-width: 321px) {
    .selectdropdown_responsive {
      width: 100% !important;
    }
    .container_for_assigned_unassigned {
      display: block;
    }
    .consingment_container_two {
      display: block;
    }
    .consingment_container {
      margin-top: 25px !important;
    }
    .responsive_containerone {
      display: flex;
      gap: 09px;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 15px !important;
    }
    .consingment_container {
      margin: 3px !important;
    }
    .datsource_length {
      margin-top: 2px !important;
    }
  }
  @media (min-width: 322px) and (max-width: 376px) {
    .selectdropdown_responsive {
      width: 100% !important;
    }
    .container_for_assigned_unassigned {
      display: block;
    }
    .consingment_container_two {
      display: block;
    }
    .consingment_container {
      margin-top: 25px !important;
    }
    .responsive_containerone {
      display: flex;
      gap: 09px;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 15px !important;
      justify-content: space-between;
    }
    .consingment_container {
      margin: 3px !important;
    }
    .datsource_length {
      margin-top: 2px !important;
    }
  }
  @media (min-width: 377px) and (max-width: 426px) {
    .mobile_section .selectdropdown_responsive {
      width: 100% !important;
    }
    .container_for_assigned_unassigned {
      display: block;
    }
    .consingment_container_two {
      display: block;
    }
    .consingment_container {
      margin-top: 25px !important;
    }
    .responsive_containerone {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 15px !important;
      /* justify-content: space-between; */
    }
    .consingment_container {
      margin: 3px !important;
    }
    .datsource_length {
      margin-top: 2px !important;
    }
  }

  .checkbox_group_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .checkbox_group_container .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #28a745; /* green */
    border-color: #28a745;
  }

  .checkbox_group_container .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #28a745;
  }

  .checkbox_group_container
    .ant-checkbox-indeterminate
    .ant-checkbox-inner::after {
    background-color: #28a745;
  }

  .ant-collapse,
  .ant-collapse-item,
  .ant-collapse-content,
  .ant-collapse-content > .ant-collapse-content-box {
    background-color: #ebf7ed !important;
    border: none !important;
    border-radius: 8px !important;
  }
  .ant-collapse > .ant-collapse-item {
    border-bottom: none !important;
  }
  .ant-collapse .ant-collapse-header {
    border: none !important;
    box-shadow: none !important;
  }
  .trip-table .ant-table,
  .trip-table .ant-table-container,
  .trip-table .ant-table-content,
  .trip-table .ant-table-thead > tr > th,
  .trip-table .ant-table-tbody > tr > td {
    background-color: #ebf7ed !important;
    border: none !important;
  }
  .trip-table .ant-table-thead > tr > th,
  .trip-table .ant-table-tbody > tr > td {
    border-bottom: none !important;
  }

  @media screen and (min-width: 426px) and (max-width: 768px) {
    div[tabindex="0"] {
      width: 100% !important;
      height: 0vh !important;
    }
    .ant-tabs .ant-tabs-tab {
      display: inline !important;
    }
  }
`;

const TableStyle = styled.div`
  width: 100% !important;
  .footer-btn {
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    padding: 8px 10px !important;
    margin: 2px !important;
    border: none !important;
    /* width: 130px !important; */
    border-radius: 60px;
  }
  .footer_assigntrip {
    background-color: rgb(232, 255, 236) !important;
    color: #2c963d !important;
    border-radius: 10px;
  }

  @media screen and (min-width: 427px) and (max-width: 2560px) {
    width: 100% !important;
    .footer-btn {
      border-radius: 10px;
      font-size: 20px;
      font-weight: 500;
      padding: 8px 10px !important;
      margin: 2px !important;
      border: none !important;
      /* width: 130px !important; */
      border-radius: 60px;
    }
    .footer_assigntrip {
      background-color: rgb(232, 255, 236) !important;
      color: #2c963d !important;
      border-radius: 20px;
      width: 145px;
    }
  }

  .bottom-action-bar {
    position: fixed;
    bottom: 0;
    left: 250px; /* Adjust if your sidebar is a different width */
    width: calc(100% - 200px); /* Adjust if needed */
    background-color: white;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 12px 12px;
    z-index: 1000; /* Make sure it's above other content */
  }
  .bottom-action-bar button {
    padding: 8px 16px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    margin-left: 10px;
  }
  .bottom-action-bar button:nth-child(1) {
    width: 150px;
    height: 38px;
    gap: 8px;
    font-weight: 500;
    font-size: 16px;
    color: red;
    background-color: #ffffff;
  }
  .bottom-action-bar button:nth-child(2) {
    width: 150px;
    height: 38px;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: #e8ffec !important;
    color: #2c963d !important;
  }
  .bottom-action-bar button:nth-child(3) {
    width: 150px;
    height: 38px;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
    margin-right: 120px;
  }
  .container_six {
    display: flex !important;
    width: 100% !important;
    justify-content: space-between;
    align-items: center;
  }
`;

const NexusAI = () => {
  const latlongList = useSelector((state) => state?.authTracking?.latlongList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const AIVehicleLists = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );
  const fenceList = useSelector((state) => state?.authTracking?.nexusFenceList);
  const driverWithVehicle = useSelector(
    (state) => state?.authTracking?.driverWithVehicle,
  );
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const countryList = useSelector((state) => state?.authTracking?.countryList);
  const location = useLocation();
  const { consignmentRecord } = location.state || {};
  //navigation on home page function
  const { stage, shipmentTypes } = location.state || {};
  useEffect(() => {
    if (stage || shipmentTypes) {
      if (stage) handleFilterSelectChange(stage, "event");
      if (shipmentTypes) handleFilterSelectChange(shipmentTypes, "shipment");
      // When navigated from home page, force duration to empty
      filterform.setFieldValue("duration", "");
      filterform.setFieldValue("daterange", [null, null]);
      setFilterData((prev) => ({
        ...prev,
        duration: "",
        daterange: [null, null],
      }));
    }
  }, [stage, shipmentTypes]);

  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterCount, setFilterCount] = useState(0);
  const [filterData, setFilterData] = useState({
    duration: "current_month",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  const tripType = [
    {
      label: "Local",
      value: 1,
    },
    { label: userInfo?.MCID === 72 ? "Transit" : "Safari", value: 2 },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const [tripform] = Form.useForm();
  const [editTripDrawerOpen, setEditTripDrawerOpen] = useState(false);
  const [editingTripData, setEditingTripData] = useState({});
  const [editTripForm] = Form.useForm();

  // ─── DB API helpers (/nexus/consign) ─────────────────────────────────
  const DB_BASE =
    "https://ks5jby85id.execute-api.us-east-2.amazonaws.com/Prod/";
  const dbHeaders = () => {
    const raw = window?.localStorage?.getItem("token") || "";
    const token = raw.startsWith("Bearer ") ? raw : `Bearer ${raw}`;
    return { "Content-Type": "application/json", Authorization: token };
  };

  const createDbConsignment = async (payload) => {
    console.log("[createDbConsignment] calling with payload:", payload);
    try {
      const res = await fetch(`${DB_BASE}nexus/createconsign`, {
        method: "POST",
        headers: dbHeaders(),
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => null);
      console.log("[createDbConsignment] response:", res.status, data);
      return { ok: res.ok, status: res.status, data };
    } catch (err) {
      console.error("[createDbConsignment] error:", err);
      return { ok: false, status: 0, data: null, error: err };
    }
  };

  const getAllDbConsignments = (params = {}) => {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, v]) => v !== undefined && v !== null && v !== "",
      ),
    );
    const qs = new URLSearchParams(cleanParams).toString();
    console.log("[getAllDbConsignments] calling with params:", cleanParams);
    return fetch(`${DB_BASE}nexus/getallconsign${qs ? `?${qs}` : ""}`, {
      method: "GET",
      headers: dbHeaders(),
    })
      .then((r) => r.json())
      .then((res) => {
        console.log("[getAllDbConsignments] response:", res);
        return res;
      })
      .catch((err) => {
        console.error("[getAllDbConsignments] error:", err);
        return null;
      });
  };

  const updateDbConsignment = async (payload) => {
    console.log("[updateDbConsignment] calling with payload:", payload);
    try {
      const res = await fetch(`${DB_BASE}nexus/updateconsign`, {
        method: "PUT",
        headers: dbHeaders(),
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => null);
      console.log("[updateDbConsignment] response:", res.status, data);
      return { ok: res.ok, status: res.status, data };
    } catch (err) {
      console.error("[updateDbConsignment] error:", err);
      return { ok: false, status: 0, data: null, error: err };
    }
  };

  const deleteDbConsignment = async (consignId) => {
    try {
      const res = await fetch(`${DB_BASE}nexus/deleteconsign?id=${consignId}`, {
        method: "DELETE",
        headers: dbHeaders(),
      });
      const data = await res.json().catch(() => null);
      console.log("[deleteDbConsignment] response:", res.status, data);
      return { ok: res.ok, status: res.status, data };
    } catch (err) {
      console.error("[deleteDbConsignment] error:", err);
      return { ok: false, status: 0, data: null, error: err };
    }
  };
  // ─────────────────────────────────────────────────────────────────────

  // ─── Maps 3rd-party trip_id -> our DB row's real Id (needed for update/delete) ───
  const [dbIdByTripId, setDbIdByTripId] = useState({});

  const refreshDbIdMap = async () => {
    try {
      const result = await getAllDbConsignments({ pageSize: 500 });
      const rows = Array.isArray(result)
        ? result
        : Array.isArray(result?.data?.data)
          ? result.data.data
          : Array.isArray(result?.data)
            ? result.data
            : result?.response || result?.rows || [];
      const map = {};
      rows.forEach((row) => {
        const tripId = row.TripId ?? row.tripId ?? row.trip_id ?? row.Trip_Id;
        const dbId =
          row.Id ?? row.id ?? row.ID ?? row.ConsignId ?? row.consignId;
        if (tripId != null && dbId != null) {
          map[tripId] = dbId;
          map[String(tripId)] = dbId;
          map[Number(tripId)] = dbId;
        }
      });
      setDbIdByTripId(map);
    } catch (err) {
      console.error("[refreshDbIdMap] error:", err);
    }
  };

  useEffect(() => {
    refreshDbIdMap();
  }, []);

  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  // navigate home page create consinment tab
  useEffect(() => {
    if (location.state?.tab === "CreateSingleConsignment") {
      setDrawerOpen(true);
      setFormType("bulkCreate");
    }
  }, [location.state]);

  useEffect(() => {
    const duration = form.getFieldValue("duration");

    if (duration === "last_month") {
      form.setFieldValue("daterange", [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
      }));
    } else if (duration === "current_month") {
      form.setFieldValue("daterange", [
        dayjs().startOf("month"),
        dayjs().endOf("month"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs().startOf("month"), dayjs().endOf("month")],
      }));
    } else if (duration === "current_year") {
      form.setFieldValue("daterange", [
        dayjs().startOf("year"),
        dayjs().endOf("year"),
      ]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs().startOf("year"), dayjs().endOf("year")],
      }));
    } else if (duration === "today") {
      form.setFieldValue("daterange", [dayjs(), dayjs()]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [dayjs(), dayjs()],
      }));
    } else if (duration === "---") {
      form.setFieldValue("daterange", [null, null]);
      setFilterData((PrevValue) => ({
        ...PrevValue,
        ["daterange"]: [null, null],
      }));
    }

    // else {
    //   const today = dayjs();
    //   const sameDayLastMonth = today.subtract(1, 'month');
    //   form.setFieldValue("daterange", [ today, sameDayLastMonth]);
    //   setFilterData((PrevValue) => ({
    //     ...PrevValue,
    //     ["daterange"]: [
    //       today , sameDayLastMonth
    //     ],
    //   }));
    // }
  }, [form.getFieldValue("duration")]);

  useEffect(() => {
    // Set default filter only if not navigating from Home
    if (!location.state?.stage && !location.state?.shipmentTypes) {
      filterform.setFieldsValue({
        duration: "current_month",
        daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
      });
      setFilterData({
        duration: "current_month",
        daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
      });
    }
  }, []);

  //event type functionality

  const [EventType, setEventType] = useState(AIConsignmentCollectionEvents);
  const handleShipmentChange = (shipment) => {
    if (shipment === 1) {
      setEventType(AIConsignmentDeliveryEvents);
    } else if (shipment === 2) {
      setEventType(AIConsignmentCollectionEvents);
    } else {
      setEventType([AIConsignmentCombinedEvents]); // or default options
    }
  };

  const tabItems = [
    {
      key: "label1",
      label: "Assigned",
    },
    {
      key: "label2",
      label: "Unassigned",
    },
  ];

  const [visibleExport, setVisibleExport] = useState(false);
  const [visibleImport, setVisibleImport] = useState(false);
  const [visibleSort, setVisibleSort] = useState(false);
  const [assignedConsignments, setAssignedConsignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [consignmentDetails, setConsignmentDetails] = useState({});
  const [locationModal, setLocationModal] = useState(false);
  const [isCreateTrip, setIsCreateTrip] = useState(false);
  const [isConformationModal, setIsConformationModal] = useState(false);
  const [newLoading, setNewLoading] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [selectedCustomColumns, setSelectedCustomColumns] = useState([]);
  const [customDataLoaded, setCustomDataLoaded] = useState(false);
  const [formType, setFormType] = useState("bulkCreate");
  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);
  const [tripCustomFields, setTripCustomFields] = useState([]);
  const [modaldrawyer, setModaldrawer] = useState(false);
  const reftab = "AIBulkcreate";
  const [newtimeandvalue, setnewtimeandvalue] = useState(null);
  // const generateTimeandsecond = (date = new Date()) => {
  //  const d = new Date(
  //     date.toLocaleString("en-US", { timeZone: "Asia/Kolkata"  })
  //   );
  //   const pad = (n) => String(n).padStart(2, "0");
  //   const Y = d.getFullYear();
  //   const M = pad(d.getMonth() + 1);
  //   const D = pad(d.getDate());
  //   const h = pad(d.getHours());
  //   const m = pad(d.getMinutes());
  //   const s = pad(d.getSeconds());
  //   return `${Y}-${M}-${D} ${h}:${m}:${s}`;
  // };
  function generateKenyaTime(date = new Date()) {
    const options = {
      timeZone: "Africa/Nairobi",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour12: false,
    };
    const formatter = new Intl.DateTimeFormat("en-GB", options);
    const parts = formatter.formatToParts(date);

    const y = parts.find((p) => p.type === "year").value;
    const m = parts.find((p) => p.type === "month").value;
    const d = parts.find((p) => p.type === "day").value;
    const h = parts.find((p) => p.type === "hour").value;
    const min = parts.find((p) => p.type === "minute").value;
    const s = parts.find((p) => p.type === "second").value;

    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }

  let timeNow = generateKenyaTime();
  let afterOneHour = generateKenyaTime(new Date(Date.now() + 60 * 60 * 1000));

  // the account's own TraKing company (e.g. Kyoga Hauliers Limited), locked in the form
  const defaultCompany = userInfo?.NexusCompId
    ? Number(userInfo.NexusCompId)
    : userInfo?.MCID === 59
      ? ""
      : userInfo.COMPNAME;
  const [formData, setFormData] = useState({
    company: defaultCompany,
    ConsignorName: "",
    consignor:
      userInfo?.MCID === 71
        ? 14045
        : userInfo?.MCID === 46
          ? 32921
          : userInfo?.MCID === 55
            ? 1
            : "",
    transporter:
      userInfo?.MCID === 71
        ? 14046
        : userInfo?.MCID === 46
          ? 32922
          : userInfo?.MCID === 55
            ? 2
            : userInfo?.MCID === 3
              ? 91
              : "", // Auto-select for MCID 71
    consignee: [{}],
    fence: [{}],
    chargetype:
      userInfo?.MCID === 46 || userInfo?.MCID === 55
        ? 6
        : userInfo?.MCID === 3 || userInfo?.MCID === 72
          ? 3
          : "",
    priority: userInfo?.MCID === 55 ? 1 : "",
    noofdeliverables: "",
    dimension: "",
    gross: "",
    switch: false,
    plocation: "",
    pdate: userInfo?.MCID === 55 ? dayjs(timeNow) : "",
    dlocation: "",
    ddate: userInfo?.MCID === 55 ? dayjs(afterOneHour) : "",
    pnotes: "",
    dnotes: "",
    remark: "",
    linkdossier: "",
    orderno: "",
    referenceno: "",
    containerno: "",
    zone: "",
    shipmentType:
      userInfo?.MCID === 71 || userInfo?.MCID === 46 || userInfo?.MCID === 55
        ? 1
        : userInfo?.MCID === 3
          ? 2
          : "",
    dispatchtype: "0", // Regular Dispatch
    tripType: userInfo?.MCID === 55 ? 1 : userInfo?.MCID === 3 ? 2 : "",
    tripallowance: "",
    finishtype: 5, // Return to the starting point
    fuelQuantity: "",
    vehicle: "",
    device: "",
    driver: "",
    route: "",
    deliveryNo: "",
    ReferenceNo: "",
    ContainerNo: "",
    dlocationname: {},
    plocationname: {},
  });
  const [resetCount, setResetCount] = useState(0);
  const handleCreateAnotherTrip = () => {
    setFormData((prev) => ({
      ...prev,
      pdate: "",
      ddate: "",
    }));
    setResetCount((prev) => prev + 1);
  };
  useEffect(() => {
    if (formType === "bulkCreate") {
      setFormData((prev) => ({
        ...prev,
        pdate: dayjs(timeNow),
        ddate: dayjs(afterOneHour),
      }));
    }
  }, [formType, resetCount]);

  useEffect(() => {
    setnewtimeandvalue(timeNow);
    generateKenyaTime();
  }, []);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formType, form]);

  const GetAllCustomeData = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=${reftab}`,
      );

      SetAllCustomeData(data);
      setCustomDataLoaded(true);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };
  filterform.getFieldValue("daterange");

  const getAssignedConsignments = async () => {
    setLoading(true);
    try {
      const companyId = formData?.company || userInfo?.MCID || 59;
      const daterange = filterform?.getFieldValue("daterange");
      const dateFrom =
        daterange && dayjs(daterange[0]).isValid()
          ? dayjs(daterange[0]).format("YYYY-MM-DD")
          : undefined;
      const dateTo =
        daterange && dayjs(daterange[1]).isValid()
          ? dayjs(daterange[1]).format("YYYY-MM-DD")
          : undefined;

      const isAssigned = activeTab === "label1";
      const params = {
        // companyId: companyId,
        page: currentPage || 1,
        pageSize: pageSize || 10,
        search: filterData?.search || undefined,
        code: filterData?.code || undefined,
        consigner: filterData?.consignor || undefined,
        shipmentType: filterData?.shipment || undefined,
        driver: filterData?.driver || undefined,
        town: filterData?.town || undefined,
        dateFrom: dateFrom,
        dateTo: dateTo,
        containerNo: filterData?.containerno || undefined,
        deliveryNo: filterData?.deliveryNo || undefined,
        vehid: filterData?.vehicle || undefined,
        assignStatus: isAssigned ? "assigned" : "unassigned",
        event: filterData?.event || undefined,
      };

      const result = await getAllDbConsignments(params);
      const trips = Array.isArray(result)
        ? result
        : Array.isArray(result?.data?.data)
          ? result.data.data
          : Array.isArray(result?.data)
            ? result.data
            : result?.response || result?.rows || [];
      const totalCount =
        result?.data?.total ??
        result?.total ??
        result?.pagination?.total ??
        result?.count ??
        trips.length;

      // Update dbIdByTripId map from fetched rows
      const newMap = {};
      trips.forEach((trip) => {
        const tripId =
          trip.TripId ?? trip.tripId ?? trip.trip_id ?? trip.Trip_Id;
        const dbId =
          trip.Id ?? trip.id ?? trip.ID ?? trip.ConsignId ?? trip.consignId;
        if (tripId != null && dbId != null) {
          newMap[tripId] = dbId;
          newMap[String(tripId)] = dbId;
          newMap[Number(tripId)] = dbId;
        }
      });
      if (Object.keys(newMap).length > 0) {
        setDbIdByTripId((prev) => ({ ...prev, ...newMap }));
      }

      // Assigned tab -> vehicle is present; Unassigned tab -> vehicle is null/empty
      // const filteredTrips = trips.filter((trip) => {
      //     const hasVehicle = !!(trip.VehRegNo || trip.vehicle || (trip.VehId && Number(trip.VehId) !== 0));
      //     return activeTab === "label2" ? !hasVehicle : hasVehicle;
      // });

      const newData1 = trips.map((trip) => {
        const consignId = trip.consignid;
        const tripId = trip.tripid;
        const vehicleReg = trip.vehiclename || "";

        // Consignee can be a string like "129"
        const consigneeList = trip.consignee
          ? Array.isArray(trip.consignee)
            ? trip.consignee.flat().filter(Boolean)
            : String(trip.consignee)
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
          : [];

        const consigneeDisplay =
          consigneeList.length > 0 ? consigneeList.join(", ") : "-";

        const rawTrip = {
          ...trip,

          trip_id: tripId,
          company_id: trip.companyid,

          vehicle: vehicleReg || trip.vehid || "",
          device: trip.deviceid || "",
          device_id: trip.deviceid || "",

          dispatch_type: String(trip.dispatchType ?? "0"),

          consignor: trip.consigner,
          consignee: consigneeList,

          container: trip.ContainerNo || "",
          declaration_no: trip.DeclarationNo || "",

          goods_description: trip.Remarks || "",

          completion_rules: trip.completionType,

          etd: trip.pickupTime,
          eta: trip.dropTime,

          trip_number: trip.code || (consignId ? `TRP-${consignId}` : ""),

          driver_name: trip.drivername || "Unassigned",
        };

        const enrichedItem = {
          key: consignId ?? tripId,

          // Database consignment ID
          ConsignId: consignId,

          // Actual trip ID
          tripId: tripId,

          dbId: consignId,
          vehid: trip.vehid,

          cron: trip.cron || trip.pickupTime,

          Code: trip.code || "",

          VehRegNo: vehicleReg || "-",

          DriverName: trip.drivername || "-",

          CustName: trip.consigner ?? "-",

          FNAME: consigneeDisplay,

          SupName: trip.transporter ?? "-",

          location: trip.location || "-",

          StartLat: trip.StartLat || 0,
          StartLng: trip.StartLng || 0,

          ELAT: trip.EndLat || 0,
          ELNG: trip.EndLng || 0,

          ReferenceNo: trip.deliveryNo || "",

          FWayBill: trip.FWayBill || "",

          PickUpDateTime: trip.pickupTime,

          DropOffDateTime: trip.dropTime,

          LastModify: trip.status,

          // latest trip event (raw code), shown in the Event column
          lastEvent: trip.lastEvent || null,

          company_id: trip.companyid,

          rawTrip: rawTrip,
        };

        // Attach custom field values by matching REFID to ConsignId
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (field) => Number(field.REFID) === Number(consignId),
          ) || [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return enrichedItem;
      });

      setAssignedConsignments(newData1 || []);
      setTotal(totalCount || 0);
    } catch (error) {
      console.error("Error in getAssignedConsignments", error);
    } finally {
      setLoading(false);
    }
  };

  // Ensure assigned consignments are fetched only after
  // custom data and custom column configuration are ready
  useEffect(() => {
    if (
      customDataLoaded &&
      Array.isArray(customFields) &&
      customFields.length > 0 &&
      Array.isArray(selectedCustomColumns) &&
      selectedCustomColumns.length > 0
    ) {
      getAssignedConsignments();
    }
  }, [customDataLoaded, customFields, selectedCustomColumns]);

  const TRIP_REFTAB = "Trip"; // or whatever your backend expects

  const loadTripCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: TRIP_REFTAB,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setTripCustomFields(data);
    } catch (error) {
      setTripCustomFields([]);
      message.error("Failed to load trip custom fields.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (isCreateTrip) {
      loadTripCustomFields();
    }
  }, [isCreateTrip]);
  const [CreateTripCustomeData, setCreateTripCustomeData] = useState([]);

  const CustomeTripDataCreate = async (TRIPID, values) => {
    try {
      const customDataList = tripCustomFields
        .map((field) => {
          if (!field?.FIELDNAME) return null;

          const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
          const value = values?.[fieldName];

          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: TRIPID,
              Value: value,
            };
          }

          return null;
        })
        .filter(Boolean);

      if (customDataList.length === 0) {
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateTripCustomeData(data);
    } catch (error) {
      console.error("Custom field creation error:", error);
      setCreateTripCustomeData([]);
    }
  };
  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const daterange = filterform?.getFieldValue("daterange");
      const dateFrom =
        daterange && dayjs(daterange[0]).isValid()
          ? dayjs(daterange[0]).format("YYYY-MM-DD")
          : "";
      const dateTo =
        daterange && dayjs(daterange[1]).isValid()
          ? dayjs(daterange[1]).format("YYYY-MM-DD")
          : "";
      const { data } = await CALL_API("POST", "ai/consignments/getAll", {
        mcId: userInfo?.MCID,
        custName: filterData?.consignor || "",
        FID: filterData?.fence || "",
        regNo: filterData?.vehicle || "",
        status: activeTab === "label2" ? "1" : "2",
        priority: filterData?.priority || 1,
        code: filterData?.code || "",
        driverName: filterData?.driver || "",
        dateFrom: dateFrom,
        dateTo: dateTo,
        town: filterData?.town || 0,
        shipper: filterData?.transporter || "",
        ContainerNo: filterData?.containerno || "",
        ReferenceNo: filterData?.referenceno || "",
        page: 1,
        pageSize: total,
      });

      const consignmentData = data?.data || [];
      const customFieldMap = {};
      (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
        if (cf.CFID) {
          customFieldMap[cf.CFID] = cf.FIELDNAME || cf.FIELDCODE;
        }
      });
      const enrichedData = consignmentData.map((item) => {
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (f) => f.REFID === item.ConsignId,
          ) || [];

        const customFieldValues = {};

        // Ensure every custom field exists
        (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
          const fieldName = customFieldMap[cf.CFID] || `Custom_${cf.CFID}`;

          const matched = matchedFields.find((f) => f.CFID === cf.CFID);

          customFieldValues[fieldName] = matched?.VALUE || "-";
        });

        // Merge base and custom data for export
        return {
          Date: item.cron
            ? dayjs(item.cron).format("DD-MM-YYYY HH:mm:ss")
            : "-",
          "Consign Code": item.Code || "-",
          Priority: item.Priority === 1 ? "High" : "Normal",
          "Vehicle/Driver": `${item.VehRegNo || "-"}/${item.DriverName || "-"}`,
          Event:
            (item.lastEvent ? nexusEventLabel(item.lastEvent, item.rawTrip?.shipmentType) : null) ||
            (item.ShipmentType === 1
              ? AIConsignmentDeliveryEvents
              : AIConsignmentCollectionEvents
            ).find((ev) => ev.value === item.LastModify)?.name ||
            (activeTab === "label2" ? "Unassigned" : "Assigned"),
          Consignor: item.CustName || "-",
          Consignee: item.FNAME || "-",
          Transporter: item?.SupName || "-",
          Location: locationCache[`${item.EndLat},${item.EndLng}`] || "-",
          ...customFieldValues,
        };
      });

      // Export if data exists
      if (enrichedData.length > 0) {
        setCSVList(enrichedData);
        setTimeout(() => csvLinkEl.current.link.click(), 500);
      } else {
        message.error("No data available to download.");
      }

      setCSVLoader(false);
    } catch (error) {
      setCSVLoader(false);
      console.error("[prepareCSV] error -->", error);
    }
  };
  //Custome Field api calling Function

  const loadCustomFields = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: reftab,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  const [CreateCustomeData, setCreateCustomeData] = useState([]);

  const CustomeDataCreate = async (reftab, ConsignId, values) => {
    try {
      const customDataList = customFields
        .map((field) => {
          if (!field?.FIELDNAME) return null;

          const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
          const value = values?.[fieldName];

          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: ConsignId,
              Value: value,
            };
          }

          return null;
        })
        .filter(Boolean);
      if (customDataList.length === 0) {
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateCustomeData(data);
    } catch (error) {
      console.error("Custom field creation error:", error);
      setCreateCustomeData([]);
    }
  };

  //Update custom data api call functionality
  const CustomeDataUpdate = async (reftab, ConsignId, values) => {
    setLoading(true);
    try {
      // Loop through all custom fields
      for (const field of customFields) {
        const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
        const value = values?.[fieldName];

        // Find the existing custom data for this field and entity
        const existing = AllCustomeData?.find(
          (item) =>
            Number(item.REFID) === Number(ConsignId) &&
            Number(item.CFID) === Number(field.CFID),
        );

        // Only update if value is present and there is an existing record
        if (value !== undefined && value !== "") {
          if (existing) {
            // UPDATE
            const payload = {
              CfId: Number(field.CFID),
              RefId: ConsignId,
              Value: value,
              DataId: existing.DATAID,
            };
            await CALL_API("PATCH", "mastertable/updateCustomData", payload);
          } else {
            // INSERT
            await CustomeDataCreate(reftab, ConsignId, values);
          }
        }
      }
    } catch (error) {
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (reftab, ConsignId) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: ConsignId,
          RefTab: reftab,
          McId: userInfo?.MCID,
        },
      );
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadCustomFields(reftab);
    GetAllCustomeData(reftab);
  }, [reftab]);
  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [configId, setconfigId] = useState(null); // To store the ID of the consignment to delete

  const handleclickconfig = (id) => {
    setIsconfigModalVisible(true);
  };

  const handleDownloadImportSample = () => {
    const sample = [
      {
        Consignor: "ABC Exporters",
        Consignee: "XYZ Traders; PQR Stores",
        Vehicle: "KCR321W",
        Transporter: "ABC Transport",
        "Charge Type": "Container",
        "Trip Type": "Local",
        "Shipment Type": "Delivery",
        "Dispatch Type": "Single",
        "Finish Type": "Auto",
        "Pickup Date": "15/01/2026 08:00",
        "Drop Date": "15/01/2026 18:00",
        "Delivery Note": "DN-1001",
        "Container No": "MSKU1234567",
        "Trip Allowance": "2500",
      },
    ];
    const csv = XLSX.utils.sheet_to_csv(
      XLSX.utils.json_to_sheet(sample, { header: IMPORT_HEADERS }),
    );
    saveAs(
      new Blob([csv], { type: "text/csv;charset=utf-8;" }),
      "ConsignmentImportSample.csv",
    );
  };

  const showImportErrors = (title, errors) => {
    Modal.error({
      title,
      width: 640,
      content: (
        <div>
          <div style={{ maxHeight: 260, overflowY: "auto" }}>
            <ul style={{ paddingLeft: 18, margin: 0 }}>
              {errors.map((err, i) => (
                <li key={i} style={{ fontSize: 13 }}>
                  {err}
                </li>
              ))}
            </ul>
          </div>
          <p style={{ marginTop: 12, fontSize: 13, color: "#5F6D8C" }}>
            Columns: {IMPORT_HEADERS.join(", ")}.{" "}
            <a onClick={handleDownloadImportSample}>Download a sample file</a>
          </p>
        </div>
      ),
    });
  };

  // Imports a CSV / Excel file of consignments through the same create call as
  // the Create form (nexus/createconsign), one row at a time.
  const handleUpload = async (file) => {
    if (!importAllowed) return false;
    const companyId = userInfo?.NexusCompId;
    if (!companyId) {
      message.error(
        "No TraKing company is linked to this account, so consignments cannot be imported.",
      );
      return false;
    }
    try {
      setLoading(true);
      const workbook = XLSX.read(await file.arrayBuffer(), {
        type: "array",
        cellDates: true,
      });
      const sheetRows = XLSX.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[0]],
        {
          defval: "",
          raw: true,
        },
      );
      if (!sheetRows.length) {
        showImportErrors("The file has no rows", [
          "Add at least one consignment row under the header.",
        ]);
        return false;
      }

      const [assetsRes, consignors, consignees] = await Promise.all([
        fetchNexusAssets(companyId),
        fetchNexusFences("Consignor", companyId),
        fetchNexusFences("Consignee", companyId),
      ]);
      const assets = assetsRes?.response || [];
      const byName = (list, field, name) =>
        list.find(
          (x) =>
            String(x[field]).trim().toLowerCase() ===
            String(name).trim().toLowerCase(),
        );

      const errors = [];
      let created = 0;
      for (let i = 0; i < sheetRows.length; i += 1) {
        const row = sheetRows[i];
        const label = `Row ${i + 2}`;
        const cell = (h) => importCell(row, h);
        if (IMPORT_HEADERS.every((h) => String(cell(h)).trim() === ""))
          continue; // blank line

        const consignorName = String(cell("Consignor")).trim();
        const consignor = consignorName
          ? byName(consignors, "name", consignorName)
          : null;
        if (!consignor) {
          errors.push(`${label}: consignor "${consignorName}" was not found.`);
          continue;
        }
        const consigneeNames = String(cell("Consignee"))
          .split(/[;|]/)
          .map((n) => n.trim())
          .filter(Boolean);
        if (!consigneeNames.length) {
          errors.push(`${label}: consignee is required.`);
          continue;
        }
        const consigneeRows = consigneeNames.map((n) =>
          byName(consignees, "name", n),
        );
        const missingConsignee = consigneeNames.find(
          (n, idx) => !consigneeRows[idx],
        );
        if (missingConsignee) {
          errors.push(
            `${label}: consignee "${missingConsignee}" was not found.`,
          );
          continue;
        }

        const vehicleName = String(cell("Vehicle")).trim();
        const asset = vehicleName
          ? byName(assets, "asset_name", vehicleName)
          : null;
        if (vehicleName && !asset) {
          errors.push(
            `${label}: vehicle "${vehicleName}" was not found in your fleet.`,
          );
          continue;
        }

        const transporterName = String(cell("Transporter")).trim();
        const transporter = transporterName
          ? byName(transporterList || [], "Name", transporterName)
          : null;
        if (transporterName && !transporter) {
          errors.push(
            `${label}: transporter "${transporterName}" was not found.`,
          );
          continue;
        }

        const typeFields = [
          ["Charge Type", chargetype, "chargetype"],
          [
            "Trip Type",
            userInfo?.MCID === 72 ? PanTripTypeEnum : TripTypeEnum,
            "tripType",
          ],
          ["Shipment Type", shipmentType, "shipmentType"],
          ["Dispatch Type", DispatchType, "dispatchType"],
          ["Finish Type", NexusFinishType, "completionType"],
        ];
        const types = {};
        let typeError = null;
        for (const [header, list, key] of typeFields) {
          const value = enumValue(list, cell(header));
          if (value === null) {
            typeError = `${label}: ${header.toLowerCase()} "${cell(header)}" is not valid.`;
            break;
          }
          types[key] = value;
        }
        if (typeError) {
          errors.push(typeError);
          continue;
        }

        const pickup = parseImportDate(cell("Pickup Date"));
        const drop = parseImportDate(cell("Drop Date"));
        if (!pickup) {
          errors.push(`${label}: pickup date is required (DD/MM/YYYY HH:mm).`);
          continue;
        }
        if (cell("Drop Date") !== "" && !drop) {
          errors.push(`${label}: invalid drop date.`);
          continue;
        }

        const consigneeIds = consigneeRows.map((c) => String(c.geofence_id));
        const consigneeNameMap = {};
        consigneeRows.forEach((c) => {
          consigneeNameMap[String(c.geofence_id)] = c.name;
        });

        const payload = {
          vehid: asset?.asset_id,
          vehicleName: asset?.asset_name || null,
          driverId: asset?.master_driver_id ?? null,
          driverName: asset?.driver_name || asset?.master_driver_name || null,
          consigner: String(consignor.geofence_id),
          consignorName: consignor.name,
          consignee: consigneeIds,
          consigneeNames: consigneeNameMap,
          transporter: transporter?.ID,
          chargetype: types.chargetype,
          companyid: userInfo?.MCID,
          mcid: userInfo?.MCID,
          tripType: types.tripType,
          pickuptime: dayjs(pickup).toISOString(),
          droptime: drop ? dayjs(drop).toISOString() : undefined,
          dispatchType: types.dispatchType,
          shipmentType: types.shipmentType,
          completionType: types.completionType,
          deviceId: asset?.device_imei || null,
          deliveryNo: String(cell("Delivery Note")).trim() || undefined,
          container: String(cell("Container No")).trim() || null,
          // the allowance is saved on the trip, so only rows with a vehicle keep it
          tripallowance:
            asset && String(cell("Trip Allowance")).trim() !== ""
              ? cell("Trip Allowance")
              : null,
        };

        const result = await createDbConsignment(payload);
        if (result?.ok) {
          created += 1;
        } else {
          errors.push(
            `${label}: ${result?.data?.data || result?.data?.message || result?.data?.Message || "could not be created."}`,
          );
        }
      }

      if (created > 0) {
        message.success(
          `${created} ${created === 1 ? "consignment" : "consignments"} imported.`,
        );
        getAssignedConsignments();
        refreshDbIdMap();
      }
      if (errors.length) {
        showImportErrors(
          created > 0
            ? `${created} imported, ${errors.length} could not be imported`
            : "No consignments were imported",
          errors,
        );
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Something went wrong while reading the file.");
    } finally {
      setLoading(false);
    }

    return false; // Prevent default upload behavior
  };

  //device and route list functionality
  const [routeList, setRouteList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [nexusDeviceList, setNexusDeviceList] = useState([]);
  const [nexusVehicleList, setNexusVehicleList] = useState([]);
  const [nexusCompanyList, setNexusCompanyList] = useState([]);
  const [consignorFenceList, setConsignorFenceList] = useState([]);
  const [filterConsignorFences, setFilterConsignorFences] = useState([]);
  const [consigneeFenceList, setConsigneeFenceList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [tripMonitorData, setTripMonitorData] = useState([]);
  const [allFenceList, setAllFenceList] = useState([]);
  const [allVehicleList, setAllVehicleList] = useState([]);

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      setVehicleList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const fetchAllRoute = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllRoute");
      setRouteList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      const devices = data?.companies || [];
      setDeviceList(devices);

      // Extract FGUIDs from devices
      const fguids = devices.map((d) => d.FGUID).filter(Boolean);

      // If we have FGUIDs, call trip monitor
      if (fguids.length > 0) {
        fetchTripMonitor(fguids);
      }
    } catch (error) {
      console.error("[fetchAllDevice] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllNexusCompany = useCallback(async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${TRAKING_API_BASE}/traking/allCompany`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );

      const companies = await response.json();

      setNexusCompanyList(companies.response || []);
    } catch (error) {
      console.error("[fetchAllNexusCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllNexusDevice = useCallback(async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${TRAKING_API_BASE}/device/getAll`,
        {
          method: "GET",
          headers: {
            "x-api-key": "trackright-secure-api-key-123",
            "Content-Type": "application/json",
          },
        },
      );

      const devices = await response.json();
      console.log("DEVICESS", devices);
      setNexusDeviceList(devices?.response ?? []);
    } catch (error) {
      console.error("[fetchAllDevice] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllNexusVehicle = useCallback(async (companyId) => {
    try {
      setLoading(true);

      const vehicles = await fetchNexusAssets(companyId);
      if (!companyId) {
        setAllVehicleList(vehicles?.response ?? []);
      }

      setNexusVehicleList(vehicles?.response ?? []);
    } catch (error) {
      console.error("[fetchAllNexusVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Consignor / Consignee fences for a company (GET /traking/getFenceByGroupName).
  // /geofence/getByGroupName needs a TraKing login session; this one takes the API key.
  const fetchFenceByCompanyId = useCallback(async (groupName, companyId) => {
    if (!groupName) return [];
    try {
      return await fetchNexusFences(groupName, companyId);
    } catch (error) {
      console.error("[fetchFenceByCompanyId] error:", error);
      return [];
    }
  }, []);

  // Consignors for the list filter: the logged-in company's own consignor fences
  // (the operator, MCID 59, has no single company, so no options)
  useEffect(() => {
    if (userInfo?.MCID === 59 || !userInfo?.NexusCompId) return;
    fetchFenceByCompanyId("Consignor", userInfo.NexusCompId).then(
      setFilterConsignorFences,
    );
  }, [userInfo?.MCID, userInfo?.NexusCompId, fetchFenceByCompanyId]);

  useEffect(() => {
    const fetchFences = async () => {
      try {
        const response = await fetch(
          `${TRAKING_API_BASE}/traking/listAllFence`,
          {
            method: "GET",
            headers: {
              "x-api-key": "trackright-secure-api-key-123",
              "Content-Type": "application/json",
            },
          },
        );
        const data = await response.json();
        setAllFenceList(data?.response || []);
      } catch (error) {
        console.error("[fetchFenceByCompanyId] error:", error);
      }
    };
    fetchFences();
  }, []);

  const fetchTripMonitor = useCallback(async (aDevices) => {
    try {
      const { data } = await CALL_API("POST", "container/tripMonitorList", {
        aDevices,
      });
      setTripMonitorData(data?.Result || []);
    } catch (error) {
      console.error("[fetchTripMonitor] error:", error);
    }
  }, []);

  useEffect(() => {
    fetchAllCompany();
    fetchAllVehicle();
    fetchAllRoute();
    fetchAllDevice();
    fetchAllNexusDevice();
    fetchAllNexusVehicle();
    fetchAllNexusCompany();
  }, []);

  //fectch  vehicle,device,route per company
  const [filteredVehicleList, setFilteredVehicleList] = useState([]);
  const [filteredDeviceList, setFilteredDeviceList] = useState([]);
  const [filteredRouteList, setFilteredRouteList] = useState([]);
  const [filteredFenceList, setFilteredFenceList] = useState([]);

  const handleCompanyChange = (companyId) => {
    try {
      if (!companyId) {
        setFilteredVehicleList([]);
        setFilteredDeviceList([]);
        setFilteredRouteList([]);
        setFilteredFenceList([]);
        setVehicleOptions([]);
        return;
      }

      const filteredFences = fenceList.filter(
        (v) => v.company_id === companyId,
      );
      const filteredVehicles = nexusVehicleList;
      const filteredDevices = nexusDeviceList;
      const filteredRoutes = routeList.filter(
        (r) => r.FAgentGUID === companyId,
      );
      setFilteredVehicleList(filteredVehicles);
      setFilteredDeviceList(filteredDevices);
      setFilteredRouteList(filteredRoutes);
      setFilteredFenceList(filteredFences);

      // Fetch assets for the selected company from 3rd-party API
      fetchAssetsByCompany(companyId);
    } catch (error) {
      console.error("[handleCompanyChange] error:", error);
    }
  };
  useEffect(() => {
    // an account linked to a TraKing company always uses that company; only the
    // operator account (59) picks one
    const companyId =
      userInfo?.NexusCompId || (userInfo?.MCID === 59 ? formData?.company : "");
    handleCompanyChange(companyId);
    fetchAssetsByCompany(companyId);
  }, [formData.company, userInfo?.NexusCompId, vehicleList, deviceList, routeList]);

  useEffect(() => {
    if (!formData?.company) {
      setConsignorFenceList([]);
      setConsigneeFenceList([]);
      return;
    }
    fetchFenceByCompanyId("Consignor", formData.company).then(
      setConsignorFenceList,
    );
    fetchFenceByCompanyId("Consignee", formData.company).then(
      setConsigneeFenceList,
    );
  }, [formData?.company, fetchFenceByCompanyId]);

  const [vehicleOptionss, setVehicleOptions] = useState([]); // for vehicle dropdown
  const [vehicleLoading, setVehicleLoading] = useState(false); // loading state for vehicle dropdown
  const [deviceOptionss, setDeviceOptions] = useState([]); // for device dropdown

  const fetchAssetsByCompany = async (companyId) => {
    if (!companyId) {
      setVehicleOptions([]);
      return;
    }
    setVehicleLoading(true);
    try {
      const data = await fetchNexusAssets(companyId);
      setVehicleOptions(
        Array.isArray(data?.response)
          ? data.response.map((a) => ({
              value: a.asset_id,
              label: a.asset_name,
              device_imei: a.device_imei || a.device_name || a.device_id || "",
              driverId: a.master_driver_id ?? null,
              driverName: a.master_driver_name || a.driver_name || "",
            }))
          : [],
      );
    } catch (error) {
      console.error("[fetchAssetsByCompany] error:", error);
      setVehicleOptions([]);
    } finally {
      setVehicleLoading(false);
    }
  };

  // Driver dropdown: the company's drivers, taken from its vehicles
  const driverOptions = useMemo(() => {
    const seen = new Map();
    vehicleOptionss.forEach((v) => {
      if (!v.driverName) return;
      const value = v.driverId ?? v.driverName;
      if (!seen.has(value)) seen.set(value, { value, label: v.driverName });
    });
    return [...seen.values()].sort((a, b) => String(a.label).localeCompare(String(b.label)));
  }, [vehicleOptionss]);

  const handleVehicleChange = async (vehicleFGUID) => {
    const selectedVehicle = filteredVehicleList.find(
      (item) => item.asset_id === vehicleFGUID,
    );
    if (!selectedVehicle) return;
    setLoading(true);
    try {
      const data = await fetchNexusAssetInfo(selectedVehicle?.asset_id);
      const device = data?.response?.device_name;
      if (device) {
        tripform.setFieldValue("device", device);
        setFormData((prev) => ({ ...prev, device: device }));
      } else {
        tripform.setFieldValue("device", undefined);
      }
    } catch (err) {
      tripform.setFieldValue("device", undefined);
    } finally {
      setLoading(false);
    }
  };
  const handleDeviceChange = async (assetId) => {
    const selectedDevice = filteredDeviceList.find(
      (d) => d.device_id === assetId,
    );
    if (!selectedDevice) return;
    setLoading(true);
    try {
      const res = await CALL_API("POST", "ai/getVehicleInfo", {
        FAssetID: selectedDevice.FAssetID,
      });
      const company = res?.data?.companies?.[0];

      if (company?.FGUID) {
        tripform.setFieldValue("vehicle", company.FGUID);
        setFormData((prev) => ({ ...prev, vehicle: company.FGUID }));
      } else {
        tripform.setFieldValue("vehicle", undefined);
      }
    } catch (err) {
      tripform.setFieldValue("vehicle", undefined);
    } finally {
      setLoading(false);
    }
  };
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "CRC"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "UPC"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "DC"),
    [reduxPermissions],
  );
  const copyAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "CYC"),
    [reduxPermissions],
  );
  const importAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "IC"),
    [reduxPermissions],
  );
  const exportAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "EX"),
    [reduxPermissions],
  );
  const assignAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "CAT"),
    [reduxPermissions],
  );

  const addTripAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "AT"),
    [reduxPermissions],
  );

  const companyOptions = useMemo(() => {
    const options = (nexusCompanyList || []).map((item) => ({
      value: item.company_id,
      label: item.company_name,
    }));
    // the account's own company may be missing from allCompany (or not loaded yet);
    // fall back to its name so the locked field never shows a bare id
    const ownId = Number(userInfo?.NexusCompId);
    if (ownId && !options.some((o) => Number(o.value) === ownId)) {
      options.push({ value: ownId, label: userInfo?.COMPNAME || String(ownId) });
    }
    return options;
  }, [nexusCompanyList, userInfo?.NexusCompId, userInfo?.COMPNAME]);
  const vehicleOptions = nexusVehicleList?.map((item) => ({
    value: item.asset_id,
    label: item.asset_name,
    vehicleTypeId: item.FVehicleTypeID,
    DriverName: item.FDriverName,
  }));
  // const routeOptions = filteredRouteList.map((item) => ({
  //   value: item.FRouteGUID,
  //   label: item.FRouteName,
  // }));
  const deviceOptions = filteredDeviceList?.map((item) => ({
    value: item.device_id,
    label: item.device_name,
  }));

  console.log("DEVICE", deviceOptions);
  const handleTripCreate = async (values) => {
    setLoading(true);
    try {
      const selectedVehicle = vehicleOptions.find(
        (v) => String(v.value) === String(values.vehicle),
      );
      const vehRegNo = selectedVehicle?.label || "";
      const vehTypeId = selectedVehicle?.vehicleTypeId || null;
      const Drivername = selectedVehicle?.DriverName || "";

      const deviceName =
        deviceOptions.find((d) => String(d.value) === String(values.device))
          ?.label || "";

      // const routeName =
      //   routeOptions.find((r) => String(r.value) === String(values.route))
      //     ?.label || "";

      const companyName =
        companyOptions.find((c) => String(c.value) === String(values.company))
          ?.label || "";

      const FVehicleGUID = vehicleList?.find(
        (v) => v.FVehicleName === values.vehicle,
      )?.FGUID;
      const FDeviceGUID =
        filteredDeviceList?.find((d) => d.FAssetID === values.device)?.FGUID ||
        "";
      const { data, total } = await CALL_API("POST", "ai/trip/createTrip", {
        McId: userInfo?.MCID,
        Company: userInfo?.MCID === 59 ? companyName : userInfo?.COMPNAME || "",
        //DeliverNo:values.deliverNo,
        // VehId: FVehicleGUID,
        // VehRegNo:  values.vehicle,
        // VTypeId: vehTypeId,
        VehId: values.vehicle,
        VehRegNo: vehRegNo,
        VTypeId: vehTypeId,
        DriverName: Drivername,
        Remarks: values.remark,
        userId: userInfo?.UID,
        TripType: values.tripType,
        DispatchTypeID: values.dispatchtype.toString(),
        FinishType: values.finishtype,
        ShipmentTypeId: values.shipmentType,
        TripAllowance: values.tripallowance,
        FuelQuantity: values.fuelQuantity,
        DeviceID: FDeviceGUID,
        DeviceName: values.device,
        RouteID: values.route || "",
        RouteName: "",
        FWayBill: values.deliveryNo,
        PickUpDateTime: values.pdate,
        DropOffDateTime: values.ddate,
        // ConsignId: values.ConsignId,
        ConsignmentIds: selectedRowKeys,
      });

      const TripId = data?.TripId || data?.TRIPID || data?.result?.TRIPID;
      // Save custom fields for the trip
      if (TripId) {
        await CustomeTripDataCreate(TripId, values);
        tripform?.resetFields();
        setIsCreateTrip(false);
        setSelectedRows([]);
        setSelectedRowKeys([]);
        await getAssignedConsignments();
        message.success("Trip created successfully!");
      } else {
        console.error("TripId not found in API response:", data);
        message.error(data);
      }

      setLoading(false);
    } catch (error) {
      console.error("[handleTripCreate] error -->", error);
      message.error("Failed to create trip. Please try again.");
      setLoading(false);
    }
  };

  const handleTooltipVisibleChangeExport = (visible) => {
    setVisibleExport(visible);
    hideTooltipArrow();
  };

  const handleTooltipVisibleChangeImport = (visible) => {
    setVisibleImport(visible);
    hideTooltipArrow();
  };

  const handleTooltipVisibleChangeSort = (visible) => {
    setVisibleSort(visible);
    hideTooltipArrow();
  };

  // const hideTooltipArrow = () => {
  //   setTimeout(() => {
  //     const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
  //     tooltipArrows.forEach((arrow) => {
  //       arrow.style.display = "none";
  //     });
  //   }, 0);
  // };

  const hideTooltipArrow = () => {
    setTimeout(() => {
      const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
      tooltipArrows.forEach((arrow) => {
        arrow.style.display = "none";
      });
    }, 0);
  };

  const [sortField, setSortField] = useState(null);

  const handleSortOptionChange = (value) => {};
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "label1",
  ); // Default to "Assigned"
  const [consignee, setConsignee] = useState(null);
  const [hoveredrow, setHoveredrow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [copyId, setCopyId] = useState(null);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData((prevValue) => ({ ...prevValue, [name]: value }));
  };
  const csvLinkEl = useRef();

  const [isEditing, setIsEditing] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [assignVehicleId, setAssignVehicleId] = useState(null);
  const [assignDriverId, setAssignDriverId] = useState([]);
  const [getCodebyvehicle, setCodebyVehicle] = useState([]);
  const [getcode, setGetcode] = useState(null);
  const [codeList, setCodeList] = useState([]);
  const [selectedTripCode, setSelectedTripCode] = useState(null);
  const [assignTripId, setAssignTripId] = useState(null);
  const [pickupDropoffLocations, setPickupDropoffLocations] = useState([]);
  const getpickupDropoff = async () => {
    try {
      const { data } = await CALL_API(
        "GET",
        `consign/getpickupDropofflocation?ENTID=${formData?.consignor}&MCID=${userInfo?.MCID}`,
        {},
      );
      const locations = Array.isArray(data?.data) ? data.data : [];
      // setPickupDropoffLocations(data || []);
      setFormData((prev) => ({
        ...prev,
        plocation: data?.[0]?.ADDRESS,
        plocationname: {
          latitude: data?.[0]?.LATITUDE || 0,
          longitude: data?.[0]?.LONGITUDE || 0,
          place_name: data?.[0]?.ADDRESS || 0,
        },
      }));
      if (locations[0]?.ADDRESS) {
        AddEditFormm?.setFieldsValue?.({ plocation: locations[0]?.ADDRESS });
        BulkCreateForm?.setFieldsValue?.({ plocation: locations[0]?.ADDRESS });
      }
    } catch (error) {
      console.error("getpickupDropoff error -->", error);
    }
  };
  const [locationCache, setLocationCache] = useState({});

  useEffect(() => {
    getpickupDropoff();
  }, [formData?.chargetype, formData?.consignor]);

  const onTripCodeSelect = (code) => {
    setSelectedTripCode(code);
    const selected = codeList?.find((item) => item?.Code === code);
    if (selected) {
      setAssignTripId(selected?.TripId);
    }
  };
  const getCodeByVehicleId = async (vehicleId) => {
    try {
      const { data } = await CALL_API(
        "GET",
        `aiconsign/getCodebyVehicle?VehRegNo=${assignVehicleId}`,
        {},
      );
      setCodeList(data || []);
    } catch (error) {
      console.error("getCodeByVehicleId error -->", error);
    }
  };

  const driveridone = driverWithVehicle?.find(
    (vehicle) => vehicle?.VEHID === assignVehicleId,
  );
  useEffect(() => {
    getCodeByVehicleId();
  }, [assignVehicleId]);

  const AssignedVehicle = async () => {
    if (!assignTripId) {
      message.warning("Please select a trip code.");
      return;
    }

    setLoading(true);
    const { data } = await CALL_API("POST", `aiconsignment/assign_trip`, {
      TripId: assignTripId,
      ConsignmentIds: selectedRowKeys,
      UserId: userInfo?.UID,
      // vehicleId: getcode,
    });
    setAssignModal(false);
    setSelectedRowKeys([]);
    getAssignedConsignments();
    setLoading(false);

    message.success("Trip assigned successfully.");
  };

  // const getCodeByVehicle = async (vehicleId) => {
  //   try {
  //     const { data } = await CALL_API(
  //       "GET",
  //       `consign/getCodebyVehicle?vehicleId=${vehicleId}`,
  //       {}
  //     );
  //     setCodeList(data || []);
  //   } catch (error) {
  //     console.error("getCodeByVehicleId error -->", error);
  //   }
  // };

  // useEffect(() => {
  //   getCodebyVehicle();
  // }, []);
  const editUser = (record) => {
    setIsEditing(true);
    setFormData(record);
    setDrawerOpen(true);
  };

  const handleCancel = () => {
    setIsEdit(false);
    setConsignee(false);
    setDrawerOpen(false);
    setFormType("");
    setFormData({
      company: defaultCompany,
      ConsignorName: "",
      consignor:
        userInfo?.MCID === 71
          ? 14045
          : userInfo?.MCID === 46
            ? 32921
            : userInfo?.MCID === 55
              ? 1
              : "",
      transporter:
        userInfo?.MCID === 71
          ? 14046
          : userInfo?.MCID === 46
            ? 32922
            : userInfo?.MCID === 55
              ? 2
              : userInfo?.MCID === 3
                ? 91
                : "", // Auto-select for MCID 71
      consignee: [{}],
      chargetype:
        userInfo?.MCID === 46 || userInfo?.MCID === 55
          ? 6
          : userInfo?.MCID === 3 || userInfo?.MCID === 72
            ? 3
            : "",
      priority: userInfo?.MCID === 55 ? 1 : "",
      noofdeliverables: "",
      dimension: "",
      gross: "",
      switch: false,
      plocation: "",
      pdate: userInfo?.MCID === 55 ? dayjs(timeNow) : "",
      dlocation: "",
      ddate: userInfo?.MCID === 55 ? dayjs(afterOneHour) : "",
      fence: [{}],
      pnotes: "",
      dnotes: "",
      remark: "",
      linkdossier: "",
      orderno: "",
      referenceno: "",
      containerno: "",
      zone: "",
      shipmentType:
        userInfo?.MCID === 71 || userInfo?.MCID === 46 || userInfo?.MCID === 55
          ? 1
          : userInfo?.MCID === 3
            ? 2
            : "",
      dispatchtype: "0", // Regular Dispatch
      tripType: userInfo?.MCID === 55 ? 1 : userInfo?.MCID === 3 ? 2 : "",
      tripallowance: "",
      finishtype: 5, // Return to the starting point
      fuelQuantity: "",
      vehicle: "",
      device: "",
      driver: "",
      route: "",
      deliveryNo: "",
      dlocationname: {},
      plocationname: {},
      ReferenceNo: "",
      ContainerNo: "",
      containerno: "",
    });
    form.resetFields();
  };

  const handleClickme = (record) => {
    setHoveredrow(record.key);
  };
  const handleClickeditdrawer = (event, record) => {
    setDrawerOpen(true);
    event.stopPropagation();
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setPageSize(10);
    setCurrentPage(1);
    setSelectedKeys([]);
  };

  const [selectedKeys, setSelectedKeys] = useState([]);

  const handleCheckboxChange = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const [selectedRows, setSelectedRows] = useState([]);

  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRows(selectedRowKeys);
  //   },
  // };

  const [showModal, SetshowModal] = useState(false);

  const [resolveModal, setResolveModal] = useState(false);
  const [sortFields, setSortFields] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isBulkDeleteModalVisible, setIsBulkDeleteModalVisible] =
    useState(false);
  const handleresolveopen = () => {
    setResolveModal(true);
  };

  const handleresolveclose = () => {
    setResolveModal(false);
  };
  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const closeEditModal = () => {
    setResolveModal(false);
  };
  const editModuleupdate = () => {
    filterform?.resetFields();
    setFilterData({
      duration: "today",
      daterange: [dayjs(), dayjs()],
    });
  };

  const handleLocationSelect = (location) => {
    if (!location || !location.center) return;

    const [longitude, latitude] = location.center;

    setFormData((prev) => ({
      ...prev,
      [selectedItem]: location.place_name,
      [`${selectedItem}name`]: {
        place_name: location.place_name,
        latitude,
        longitude,
      },
    }));

    setLocationModal(false);
  };

  const selectedColumns = [
    {
      title: "Date",
      dataIndex: "cron",
      key: "cron",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
    },
    {
      title: "Pickup Location",
      dataIndex: "StartLocation",
      key: "StartLocation",
    },
    {
      title: "Dropoff Location",
      dataIndex: "EndLocation",
      key: "EndLocation",
    },
    {
      title: "Pickup Date Time",
      dataIndex: "PickUpDateTime",
      key: "PickUpDateTime",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Dropoff Date Time",
      dataIndex: "DropOffDateTime",
      key: "DropOffDateTime",
      render: (text) => {
        return moment(text).format("Do MMM YYYY; hh:mm A");
      },
    },
    {
      title: "Volume",
      dataIndex: "location",
      key: "location",
    },
  ];
  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };
  const dynamicCustomColumns = useMemo(() => {
    if (!Array.isArray(customFields) || customFields.length === 0) return [];
    return customFields
      .filter((field) => selectedCustomColumns.includes(field.CFID))
      .map((field) => ({
        title: field.FIELDNAME,
        dataIndex: field.CFID,
        key: field.CFID,
        sorter: false,
        render: (text) => text || "-",
      }));
  }, [customFields, selectedCustomColumns]);
  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
        label: field.FIELDNAME,
        value: field.CFID,
        disabled: false,
      }))
    : [];
  const [expandedRows, setExpandedRows] = useState({});

  const toggleViewMore = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const baseColumns = [
    {
      title: "Date",
      dataIndex: "cron",
      key: "cron",
      sorter: sortFields?.includes("Date")
        ? (a, b) => new Date(b.cron) - new Date(a.cron)
        : false,
      render: (value) => {
        if (!value) return "-";

        const d = new Date(value);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
      },
    },
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
      sorter: sortFields?.includes("Order No")
        ? (a, b) => a.Code.localeCompare(b.Code)
        : false,

      render: (code, record) => {
        return (
          <>
            {code} <div></div>
          </>
        );
      },
    },
    {
      title: "Vehicle / Driver",
      dataIndex: "vehid",
      key: "vehid",
      render: (text, record) => (
        <div>
          <div>
            {allVehicleList.find((x) => x.asset_id == text)?.asset_name ||
              (record.VehRegNo !== "-" ? record.VehRegNo : "")}
          </div>
          {record.DriverName && record.DriverName !== "-" && (
            <div style={{ color: "#979797", fontSize: 13 }}>{record.DriverName}</div>
          )}
        </div>
      ),
    },
    {
      title: "Event",
      dataIndex: "LastModify",
      key: "LastModify",
      render: (text, record) => {
        // latest trip event, named the same as on the details pages
        if (record.lastEvent) {
          return nexusEventLabel(record.lastEvent, record.rawTrip?.shipmentType);
        }
        return activeTab === "label2" ? "Unassigned" : "Assigned";
      },
    },

    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      sorter: sortFields?.includes("consignee")
        ? (a, b) => a.CustName.localeCompare(b.CustName)
        : false,
      ellipsis: false, // Disable truncation to allow wrapping
      render: (text) => (
        <div className="text-wrap">
          {allFenceList.find((fence) => fence.geofence_id == text)?.name}
        </div>
      ), // Wrap text
    },
    {
      title: "Consignee",
      dataIndex: "FNAME",
      key: "FNAME",
      sorter: sortFields.includes("consignorrr")
        ? (a, b) => a.FNAME.localeCompare(b.FNAME)
        : false,
      ellipsis: false, // Disable truncation to allow wrapping
      render: (text) => (
        <div className="text-wrap">
          {allFenceList.find((fence) => fence.geofence_id == text)?.name}
        </div>
      ), // Wrap text
    },
    // {
    //     title: "Location",
    //     dataIndex: "location",
    //     key: "location",
    //     width: "20%",
    //     sorter: sortFields.includes("Location")
    //         ? (a, b) => a.location.localeCompare(b.location)
    //         : false,
    //     render: (_, record) => {
    //         const key = record.key;
    //         const isExpanded = expandedRows[key];

    //         return (
    //             <LocationCell
    //                 startLat={record.StartLat}
    //                 startLng={record.StartLng}
    //                 endLat={record.ELAT}
    //                 endLng={record.ELNG}
    //                 locationCache={locationCache}
    //                 setLocationCache={setLocationCache}
    //                 renderText={(locationText) => {
    //                     const truncated =
    //                         locationText?.length > 50 && !isExpanded
    //                             ? `${locationText.substring(0, 50)}...`
    //                             : locationText;

    //                     return (
    //                         <div>
    //                             <p
    //                                 style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
    //                             >
    //                                 {truncated}
    //                             </p>

    //                             {locationText?.length > 50 && (
    //                                 <span
    //                                     style={{ color: "#2C963D", cursor: "pointer" }}
    //                                     onClick={(e) => {
    //                                         e.stopPropagation();
    //                                         toggleViewMore(key);
    //                                     }}
    //                                 >
    //                                     {isExpanded ? "View Less" : "View More"}
    //                                 </span>
    //                             )}
    //                         </div>
    //                     );
    //                 }}
    //             />
    //         );
    //     },
    // },
    ...(userInfo?.MCID === 72
      ? [
          {
            title: "Reference No",
            dataIndex: "ReferenceNo",
            key: "ReferenceNo",
            sorter: sortFields.includes("ReferenceNo")
              ? (a, b) => a.ReferenceNo.localeCompare(b.ReferenceNo)
              : false,
          },
          {
            title: "Delivery Note No",
            dataIndex: "FWayBill",
            key: "FWayBill",
            sorter: sortFields.includes("FWayBill")
              ? (a, b) => a.FWayBill.localeCompare(b.FWayBill)
              : false,
          },
        ]
      : []),
  ];
  const combinedColumns = useMemo(() => {
    const staticCols = [...baseColumns];

    // Only show custom fields that are selected
    const dynamicCols = customFields
      .filter((field) => selectedCustomColumns.includes(field.CFID))
      .map((field) => ({
        title: field.FIELDNAME,
        dataIndex: field.CFID,
        key: field.CFID,
        sorter: false,
        render: (_, record) => record?.[field.CFID] ?? "-",
      }));

    return [...staticCols, ...dynamicCols];
  }, [baseColumns, customFields, selectedCustomColumns]);
  const transporterColumn = {
    title: "Transporter",
    dataIndex: "SupName",
    key: "SupName",
    sorter: (a, b) =>
      sortFields.includes("Transporterrr")
        ? a.SupName.localeCompare(b.SupName)
        : false,
    ellipsis: false, // Disable truncation to allow wrapping
    render: (text) => {
      return (
        <div className="text-wrap">
          {transporterList.find((x) => x.ID == text)?.Name ?? "-"}{" "}
        </div>
      );
    },
  };

  const actionsColumn = {
    title: "Actions",
    key: "actions",
    width: "10%",
    render: (_, record) => (
      <div
        className={
          hoveredrow === record.key ? "d-flex gap-3 opacity-100" : "opacity-0"
        }
      >
        <Tooltip title={!copyAllowed ? "No permission" : ""}>
          <CopyIcon
            style={{ cursor: copyAllowed ? "pointer" : "not-allowed" }}
            onClick={(e) => {
              if (!copyAllowed) return;
              e.stopPropagation();
              setIsConformationModal(true);
              setCopyId(record?.ConsignId);
            }}
          />
        </Tooltip>
        <Tooltip title={!updateAllowed ? "No permission" : ""}>
          <EditIcon
            style={{
              cursor: updateAllowed ? "pointer" : "not-allowed",
              marginLeft: "10px",
            }}
            onClick={async (e) => {
              if (!updateAllowed) return;
              e.stopPropagation();

              const trip = record?.rawTrip || {};
              const consigneeArr = Array.isArray(trip.consignee)
                ? trip.consignee.flat().filter(Boolean)
                : [];

              // Load company-scoped vehicle + consignor/consignee options for this trip
              const [assetsResp, consignorResp, consigneeResp] =
                await Promise.all([
                  fetchNexusAssets(trip.company_id),
                  fetchFenceByCompanyId("Consignor", trip.company_id),
                  fetchFenceByCompanyId("Consignee", trip.company_id),
                ]);

              const assetOptions = Array.isArray(assetsResp?.response)
                ? assetsResp.response.map((a) => ({
                    value: a.asset_id,
                    label: a.asset_name,
                    device_imei:
                      a.device_imei || a.device_name || a.device_id || "",
                  }))
                : [];
              setVehicleOptions(assetOptions);
              setConsignorFenceList(consignorResp);
              setConsigneeFenceList(consigneeResp);

              const matchedAsset = assetOptions.find(
                (v) =>
                  v.label === trip.vehicle ||
                  String(v.value) === String(trip.vehicle),
              );
              const matchedVehicle = matchedAsset?.value || trip.vehicle;
              let deviceId =
                trip.device_id ||
                trip.device ||
                matchedAsset?.device_imei ||
                "";

              if (!deviceId && matchedVehicle) {
                try {
                  const devResp = await fetchNexusAssetInfo(matchedVehicle);
                  deviceId =
                    devResp?.response?.device_name ||
                    devResp?.response?.device_imei ||
                    devResp?.response?.device_id ||
                    "";
                } catch (e) {
                  console.error("[getDevice] error:", e);
                }
              }

              const initial = {
                trip_id: trip.trip_id,
                company: trip.company_id,
                vehicle: matchedVehicle,
                // name saved on the trip (trip.vehicle can be the id when none was saved)
                vehicleLabel:
                  matchedAsset?.label ||
                  (/^\d+$/.test(String(trip.vehicle ?? "")) ? "" : trip.vehicle) ||
                  "",
                device: deviceId,
                dispatchtype: trip.dispatch_type || "0",
                consignor:
                  trip.consignor !== undefined && trip.consignor !== null
                    ? String(trip.consignor)
                    : undefined,
                fence:
                  consigneeArr.length > 0
                    ? consigneeArr.map((id, idx) => ({ [idx]: String(id) }))
                    : [{}],
                containerno: trip.container || "",
                declarationNo: trip.declaration_no || "",
                remark: trip.goods_description || "",
                finishtype:
                  trip.completion_rules != null
                    ? Number(trip.completion_rules)
                    : undefined,
                pdate: trip.etd ? dayjs(trip.etd) : "",
                ddate: trip.eta ? dayjs(trip.eta) : "",
                deliveryNo: trip.trip_number || "",
                driver_name: trip.driver_name || "Unassigned",
                // Passthrough fields (not editable in this form) needed to
                // rebuild the full nexus/updateconsign payload on save.
                consignid: trip.consignid,
                code: trip.code,
                tripid: trip.tripid,
                driverId: trip.driverId,
                status: trip.status,
                chargetype: trip.chargetype,
                tripType: trip.tripType,
                shipmentType: trip.shipmentType,
                transporter: trip.transporter,
              };

              setEditingTripData(initial);
              editTripForm.setFieldsValue(initial);
              setEditTripDrawerOpen(true);
            }}
          />
        </Tooltip>
        <Tooltip title={!deleteAllowed ? "No permission" : ""}>
          <DeleteIcon
            style={{
              cursor: deleteAllowed ? "pointer" : "not-allowed",
              marginLeft: "10px",
            }}
            onClick={(e) => {
              if (!deleteAllowed) return;
              e.stopPropagation();
              setDeleteId(record?.ConsignId); // Set the ID of the consignment to delete
              setIsDeleteModalVisible(true); // Show the delete confirmation modal
            }}
          />
        </Tooltip>
      </div>
    ),
  };

  useEffect(() => {
    if (consignmentRecord && Object.keys(consignmentRecord).length) {
      setConsignmentDetails(consignmentRecord);
      setConsignee(true);
    }
  }, [consignmentRecord]);
  useEffect(() => {
    if (filterform.getFieldValue("duration") === "last_month") {
      filterform.setFieldValue("daterange", [
        moment().subtract(1, "months").startOf("month"),
        moment().subtract(1, "months").endOf("month"),
      ]);
    } else if (filterform.getFieldValue("duration") === "current_month") {
      filterform.setFieldValue("daterange", [
        moment().startOf("month"),
        moment().endOf("month"),
      ]);
    } else if (filterform.getFieldValue("duration") === "current_year") {
      filterform.setFieldValue("daterange", [
        moment().startOf("year"),
        moment().endOf("year"),
      ]);
    } else if (filterform.getFieldValue("duration") === "today") {
      filterform.setFieldValue("daterange", [moment(), moment()]);
    } else if (filterform.getFieldValue("duration") === "---") {
      filterform.setFieldValue("daterange", [null, null]);
    }
  }, [filterform.getFieldValue("duration")]);

  const additionalColumnForUnassigned = {
    title: <Checkbox />,
    dataIndex: "checkbox",
    key: "checkbox",
    width: "5%",
    render: (_, record) => (
      <Checkbox
        checked={selectedKeys.includes(record.key)}
        onChange={() => handleCheckboxChange(record.key)}
      />
    ),
  };

  const columnsForAssigned = [
    ...combinedColumns,
    transporterColumn,
    actionsColumn,
  ];
  const columnsForUnassigned = [
    // additionalColumnForUnassigned,
    ...combinedColumns.filter(
      (col) =>
        col.key !== "transporter" &&
        col.key !== "actions" &&
        col.key !== "DriverName" &&
        col.key !== "event",
    ),
    actionsColumn,
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };

  const handleFilterChange = (e) => {
    const { value, name } = e.target;
    setFilterData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };
  const handleFilterSelectChange = (field, value) => {
    setFilterData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
    if (value === "shipment") {
      setFormData((prevData) => ({
        ...prevData,
        event: field,
      }));
      handleShipmentChange(field);
    }
  };

  const currentColumns =
    activeTab === "label1" ? columnsForAssigned : columnsForUnassigned;

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const handleBulkCreateClick = () => {
    handleCreateAnotherTrip();
    setFormType("bulkCreate");
    setDrawerOpen(true);
  };
  const handleSelectChange = (value, field, fields, index = 0) => {
    if (fields === "list") {
      // setFormData((prevData) => {
      //   let updatedConsignee = [...prevData.consignee];
      //   if (updatedConsignee.length <= index) {
      //     updatedConsignee[index] = {};
      //   }
      //   updatedConsignee[index] = {
      //     ...updatedConsignee[index],
      //     [field]: value,
      //   };

      //   return {
      //     ...prevData,
      //     consignee: updatedConsignee,
      //   };
      // });
      setFormData((prevData) => {
        let updatedConsignee = [...prevData.fence];

        // Ensure the array has enough items for the selected index
        if (updatedConsignee.length <= index) {
          updatedConsignee[index] = {};
        }

        updatedConsignee[index] = {
          ...updatedConsignee[index],
          [field]: value,
        };

        return {
          ...prevData,
          fence: updatedConsignee,
        };
      });
    } else if (field === "company") {
      setFormData((prevData) => ({
        ...prevData,
        company: value,
      }));
      handleCompanyChange(value);
    } else if (field === "vehicle") {
      // the vehicle's own driver is the default; it can be changed in the Driver field
      const picked = vehicleOptionss.find((v) => String(v.value) === String(value));
      setFormData((prevData) => ({
        ...prevData,
        vehicle: value,
        driver: picked?.driverName || "",
      }));

      handleVehicleChange(value); // fetch deviceOptions based on vehicle
    } else if (field === "device") {
      setFormData((prevData) => ({
        ...prevData,
        device: value,
      }));

      handleDeviceChange(value);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
  };

  //Bulk creation add edit form
  const AddEditFormm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name] || "",
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const hasVehicle = !!formData?.vehicle;
    const baseFields = [
      [
        {
          id: 1,
          label: "Company",
          type: "selectwithvalue",
          name: "company",
          // locked to the account's own company; only the operator account (59)
          // without a linked company can choose
          disabled: !!userInfo?.NexusCompId,
          options: companyOptions,
          maxLength: 50,
          style: { width: "259px", height: "36px", gap: "10px" },
          validationRules: [{ required: true, message: "Company is required" }],
        },
        {
          id: 2,
          label: "Consignor",
          type: "selectwithvalue",
          name: "consignor",
          options: consignorFenceList?.map((item) => ({
            label: item.name,
            value: item.geofence_id,
          })),
          placeholder: "Consignor",
          style: "",
          validationRules: [
            { required: true, message: "Consignor is required" },
          ],
        },
        {
          id: 3,
          label: "Transporter",
          type: "selectwithvalue",
          name: "transporter",
          options:
            userInfo?.MCID === 71
              ? transporterList
                  ?.filter((item) => item.ID === 14046)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 46
                ? transporterList
                    ?.filter((item) => item.ID === 32922)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          placeholder: "Transporter",
          style: "",
          disabled: userInfo?.MCID === 71 || userInfo?.MCID === 46,
          validationRules: [
            { required: true, message: "Transporter is required" },
          ],
          initialValue:
            userInfo?.MCID === 71
              ? 14046
              : userInfo?.MCID === 46
                ? 32922
                : userInfo?.MCID === 55
                  ? 2
                  : undefined,
        },
        {
          id: 4,
          label: "Charge Type",
          type: "selectwithvalue",
          name: "chargetype",
          options:
            userInfo?.MCID === 46
              ? chargetype
                  ?.filter((item) => item.value === 6)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : userInfo?.MCID === 72
                ? chargetype
                    ?.filter((item) => item.value === 3)
                    .map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                : chargetype?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  })),
          disabled: userInfo?.MCID === 46 || userInfo?.MCID === 72,
          style: "",
          validationRules: [
            { required: false, message: "Charge Type is required" },
          ],
          initialValue:
            userInfo?.MCID === 46 || userInfo?.MCID === 55
              ? 6
              : userInfo?.MCID === 3 || userInfo?.MCID === 72
                ? 3
                : undefined,
        },
      ],
      [
        {
          id: 5,
          label: "Trip Type",
          type: "selectwithvalue",
          name: "tripType",
          placeholder: "Local",
          onChange: handleChange,
          maxLength: 50,
          options:
            userInfo?.MCID === 72
              ? PanTripTypeEnum?.map((item) => ({
                  label: item.name,
                  value: item.value,
                }))
              : TripTypeEnum?.map((item) => ({
                  label: item.name,
                  value: item.value,
                })),
          validationRules: [
            { required: true, message: "Trip type is required" },
          ],
        },
        {
          id: 10,
          label: "Pickup Date & Time",
          type: "date",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          name: "pdate",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.pdate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Date & Time is required" },
          ],
        },
        {
          id: 11,
          label: "Dropoff Date & Time",
          type: "date",
          name: "ddate",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.ddate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Dropoff Date Time is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const pickup = getFieldValue("pdate");
                if (!value || !pickup) return Promise.resolve();

                if (dayjs(value).isAfter(dayjs(pickup))) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    "Drop-off Date & Time must be later than Pick-up Date & Time.",
                  ),
                );
              },
            }),
          ],
        },
      ],
      [
        {
          id: 20,
          label: "Vehicle",
          type: "selectwithvalue",
          name: "vehicle",
          options: vehicleOptionss,
          loading: vehicleLoading,
          onChange: handleSelectChange,
          validationRules: [{ required: false }],
        },
        {
          id: 21,
          label: "Device",
          type: "selectwithvalue",
          name: "device",
          disabled: true,
          placeholder: "Enter Device",
          options: vehicleOptionss
            .filter((v) => v.device_imei)
            .map((v) => ({ value: v.device_imei, label: v.device_imei })),
          onChange: handleSelectChange,
          validationRules: [{ required: false }],
        },
        {
          id: 25,
          label: "Driver",
          // pick one of the company's drivers or type a name (e.g. when the
          // vehicle has no driver assigned)
          type: "textorselect",
          name: "driver",
          placeholder: "Select or type the driver's name",
          options: driverOptions,
          onChange: handleSelectChange,
          validationRules: [{ required: false }],
        },
        {},
      ],
    ];
    // Shown only after a Vehicle is picked. Vehicle itself stays optional;
    // these are the fields that become mandatory once it's filled in.
    const vehicleDependentFields = hasVehicle
      ? [
          [
            {
              id: 8,
              label: "Dispatch Type",
              type: "selectwithvalue",
              name: "dispatchtype",
              onChange: handleChange,
              options: DispatchType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              disabled: userInfo?.MCID === 3,
              placeholder: "High",
              style: "",
              validationRules: [{ required: false }],
            },
            {
              id: 9,
              label: "Shipment Type",
              type: "selectwithvalue",
              name: "shipmentType",
              onChange: handleChange,
              options:
                userInfo?.MCID === 71
                  ? shipmentType
                      ?.filter((item) => item.value === 1)
                      .map((item) => ({
                        label: item.name,
                        value: item.value,
                      }))
                  : shipmentType?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    })),
              placeholder: "High",
              style: "",
              disabled: userInfo?.MCID === 71, // disable for MCID 71
              validationRules: [
                { required: true, message: "Shipment Type is required" },
              ],
              initialValue:
                userInfo?.MCID === 71 || userInfo?.MCID === 55
                  ? 1
                  : userInfo?.MCID === 3
                    ? 2
                    : undefined, // auto-select for MCID 71
            },
            {
              id: 11,
              label: "Completion Rules",
              type: "selectwithvalue",
              name: "finishtype",
              onChange: handleChange,
              options:
                userInfo?.MCID === 71
                  ? FinishType?.filter((item) => item.value === 5).map(
                      (item) => ({
                        label: item.name,
                        value: item.value,
                      }),
                    )
                  : NexusFinishType?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    })),
              filterOption: (input, option) =>
                option?.label?.toLowerCase()?.includes(input.toLowerCase()),
              style: "",
              disabled: userInfo?.MCID === 71, // only MCID 71 is disabled
              validationRules: [
                { required: true, message: "Finish Type is required" },
              ],
              initialValue:
                userInfo?.MCID === 46 || userInfo?.MCID === 55 ? 5 : undefined, // only MCID 46 gets auto-selected
            },
            {
              id: 12,
              label: "Container No",
              type: "text",
              name: "containerno",
              placeholder: "Container No",
              maxLength: 50,
              style: "",
              validationRules: [
                { required: false, message: "Container No is required" },
              ],
            },
          ],
          [
            {
              id: 22,
              label: "Delivery Note Number",
              type: "text",
              name: "deliveryNo",
              placeholder: "Enter Device",
              validationRules: [
                { required: false, message: "Delivery No is required" },
              ],
            },
            {
              id: 23,
              label: "Remarks",
              type: "text",
              name: "remark",
              validationRules: [
                { required: false, message: "Remarks is required" },
              ],
            },
            // {
            //     id: 7,
            //     label: "Route",
            //     type: "selectwithvalue",
            //     name: "route",
            //     options: filteredRouteList?.map((item) => ({
            //         value: item.FRouteGUID,
            //         label: item.FRouteName,
            //     })),
            //     placeholder: "High",
            //     style: "",
            //     validationRules: [{ required: false }],
            // },
            // Trip allowance is saved on the trip, so it is only offered once a
            // vehicle is chosen (create) or the consignment has one (edit).
            // Unassigned consignments get it when they are assigned to a trip.
            ...((
              isEdit ? consignmentDetails?.rawTrip?.vehid : formData?.vehicle
            )
              ? [
                  {
                    id: 24,
                    label: "Trip Allowance",
                    type: "text",
                    name: "tripallowance",
                    placeholder: "0",
                    validationRules: [{ required: false }],
                  },
                ]
              : []),
          ],
          [
            {
              id: 3,
              label: "Consignee",
              type: "addfence",
              name: "fence",
              options: consigneeFenceList?.map((item) => ({
                label: item.name,
                value: item.geofence_id,
              })),
              placeholder: "",
              style: "",
              validationRules: [{ required: false }],
            },
            {},
            {},
          ],
        ]
      : [];
    const staticFields = [...baseFields, ...vehicleDependentFields];
    const allFields = [
      ...staticFields,
      // ...customFieldRows.filter((row) =>
      //     row.some((field) => Object.keys(field).length > 0),
      // ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [
    customFields,
    formData,
    consignorFenceList,
    consigneeFenceList,
    filteredRouteList,
    driverOptions,
  ]);

  const ModifyTripForm = useMemo(() => {
    const staticFields = [
      [
        {
          id: 1,
          label: "Company",
          type: "selectwithvalue",
          name: "company",
          disabled: true, // company is fixed once a trip exists
          options: companyOptions,
          validationRules: [{ required: true, message: "Company is required" }],
        },
        {
          id: 2,
          label: "Consignor",
          type: "selectwithvalue",
          name: "consignor",
          // trip.consignor is a geofence id (see the initial-value builder
          // above), not a name, so options must be keyed the same way.
          options: consignorFenceList?.map((item) => ({
            label: item.name,
            value: String(item.geofence_id),
          })),
          validationRules: [
            { required: true, message: "Consignor is required" },
          ],
        },
        {
          id: 3,
          label: "Dispatch Type",
          type: "selectwithvalue",
          name: "dispatchtype",
          options: DispatchType?.map((item) => ({
            label: item.name,
            value: item.value,
          })),
          validationRules: [
            { required: true, message: "Dispatch Type is required" },
          ],
        },
        {
          id: 4,
          label: "Completion Rules",
          type: "selectwithvalue",
          name: "finishtype",
          options: NexusFinishType?.map((item) => ({
            label: item.name,
            value: item.value,
          })),
          validationRules: [
            { required: true, message: "Completion Rules is required" },
          ],
        },
      ],
      [
        {
          id: 5,
          label: "Pickup Date & Time",
          type: "date",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          name: "pdate",
          validationRules: [
            { required: true, message: "Pickup Date & Time is required" },
          ],
        },
        {
          id: 6,
          label: "Dropoff Date & Time",
          type: "date",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          name: "ddate",
          validationRules: [
            { required: true, message: "Dropoff Date & Time is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const pickup = getFieldValue("pdate");
                if (!value || !pickup) return Promise.resolve();
                if (dayjs(value).isAfter(dayjs(pickup)))
                  return Promise.resolve();
                return Promise.reject(
                  new Error(
                    "Drop-off Date & Time must be later than Pick-up Date & Time.",
                  ),
                );
              },
            }),
          ],
        },
        {
          id: 7,
          label: "Container No",
          type: "text",
          name: "containerno",
          placeholder: "Container No",
        },
        {
          id: 8,
          label: "Declaration No.",
          type: "text",
          name: "declarationNo",
          placeholder: "Declaration No",
        },
      ],
      [
        {
          id: 9,
          label: "Vehicle",
          type: "selectwithvalue",
          name: "vehicle",
          options: vehicleOptionss,
          loading: vehicleLoading,
          onChange: (value) => {
            const selected = vehicleOptionss.find((v) => v.value === value);
            editTripForm.setFieldsValue({
              device: selected?.device_imei || "",
            });
          },
          validationRules: [{ required: true, message: "Vehicle is required" }],
        },
        {
          id: 10,
          label: "Device",
          type: "text",
          name: "device",
          disabled: true,
          placeholder: "Auto-filled from vehicle",
        },
        {
          id: 11,
          label: "Delivery Note Number",
          type: "text",
          name: "deliveryNo",
          placeholder: "Delivery Note Number",
        },
        {
          id: 12,
          label: "Remarks",
          type: "text",
          name: "remark",
          placeholder: "Goods description / remarks",
        },
      ],
      [
        {
          id: 13,
          label: "Consignee",
          type: "addfence",
          name: "fence",
          options: consigneeFenceList?.map((item) => ({
            label: item.name,
            value: String(item.geofence_id ?? item.id ?? item.name),
          })),
          validationRules: [
            { required: true, message: "Consignee is required" },
          ],
        },
        {},
        {},
      ],
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          fields: staticFields,
        },
      ],
    };
  }, [
    companyOptions,
    consignorFenceList,
    consigneeFenceList,
    vehicleOptionss,
    vehicleLoading,
  ]);
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];

  const ModalForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [12],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Consign Code</span>,
              type: "text",
              name: "code",
              placeholder: "Enter Consign Code",
              maxLength: 50,
              options: consignerList?.map((item) => ({
                value: item.ID,
              })),
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Consignor</span>,
              type: "selectwithvalue",
              name: "consignor",
              placeholder: "GCS",
              maxLength: 50,
              allowClear: true,
              options: filterConsignorFences?.map((item) => ({
                label: item.name,
                value: String(item.geofence_id),
              })),
            },
            // {
            //   id: 3,
            //   label: <span style={{ color: "#5F6D8C" }}>Transporter</span>,
            //   type: "selectwithvalue",
            //   name: "transporter",
            //   placeholder: "Cargo",
            //   maxLength: 50,
            //   options: transporterList?.map((item) => ({
            //     label: item.Name,
            //     value: item.ID,
            //   })),
            // },
            // {
            //   id: 4,
            //   label: <span style={{ color: "#5F6D8C" }}>Consignee</span>,
            //   type: "selectwithvalue",
            //   name: "consignee",
            //   placeholder: "TQS Agency",
            //   maxLength: 50,
            //   options: consigneeList?.map((item) => ({
            //     label: item.Name,
            //     value: item.ID,
            //   })),
            // },
          ],
          [
            {
              id: 5,
              label: <span style={{ color: "#5F6D8C" }}>Duration</span>,
              type: "selectwithvalue",
              name: "duration",

              placeholder: "Current Month",
              // maxLength: 50,
              options: Duration?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 6,
              label: <span style={{ color: "#5F6D8C" }}>Date Range</span>,
              type: "daterange",
              name: "daterange",
              placeholder: ["Start Date", "End Date"],
              maxLength: 50,
            },

            {
              id: 7,
              label: (
                <span style={{ color: "#5F6D8C" }}>Consignment Event</span>
              ),
              type: "selectwithvalue",
              name: "event",
              placeholder: "Accepted",
              // maxLength: 50,
              options: NEXUS_EVENT_OPTIONS,
            },
            {
              id: 8,
              label: <span style={{ color: "#5F6D8C" }}>Shipment Type</span>,
              type: "selectwithvalue",
              name: "shipment",
              placeholder: "",
              maxLength: 50,
              options: shipmentType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
            },
            // {
            //   id: 8,
            //   label: <span style={{ color: "#5F6D8C" }}>Priority</span>,
            //   type: "selectwithvalue",
            //   name: "priority",
            //   options: priorityType?.map((item) => ({
            //     label: item.name,
            //     value: item.value,
            //   })),
            //   maxLength: 30,
            // },
          ],
          [
            {
              id: 9,
              label: <span style={{ color: "#5F6D8C" }}>Driver</span>,
              type: "selectwithvalue",
              name: "driver",
              placeholder: "Tony",
              maxLength: 50,
              allowClear: true,
              options: Array.from(
                new Set(
                  (allVehicleList || [])
                    .map((a) => a.driver_name || a.master_driver_name)
                    .filter(Boolean),
                ),
              ).map((name) => ({ label: name, value: name })),
            },
            {
              id: 6,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle</span>,
              type: "selectwithvalue",
              name: "vehicle",
              placeholder: "KA12345",
              allowClear: true,
              options: (allVehicleList || []).map((a) => ({
                value: a.asset_id,
                label: a.asset_name,
              })),
            },
            {
              id: 7,
              label: <span style={{ color: "#5F6D8C" }}>Town</span>,
              type: "selectwithvalue",
              name: "town",
              placeholder: "Bern",
              maxLength: 50,
              options: Array.isArray(countryList)
                ? countryList.map((item) => ({
                    value: item.NAME,
                  }))
                : [],
            },
            {
              id: 8,
              label: <span style={{ color: "#5F6D8C" }}>Container No</span>,
              type: "text",
              name: "containerno",
              placeholder: "",
              maxLength: 50,
            },
          ],
          [
            {
              id: 9,
              label: <span style={{ color: "#5F6D8C" }}>Reference No</span>,
              type: "text",
              name: "referenceno",
              placeholder: "",
              maxLength: 50,
            },
            {},
          ],
        ],
      },
    ],
  };
  // const handleUpload = async (file) => {
  //   const formData = new FormData();
  //   formData.append("file", file); // 'file' is the key your backend will expect

  //   try {
  //     setLoading(true);
  //     const response = await axios.post(
  //       "https://ks5jby85id.execute-api.us-east-2.amazonaws.com/Prod/consignments/import",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       message.success("CSV imported successfully!");
  //       getAssignedConsignments();
  //       setLoading(false);
  //     } else {
  //       message.error("Failed to import CSV.");
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Upload error:", error);
  //     message.error("Something went wrong during upload.");
  //   }

  //   return false; // Prevent default upload behavior
  // };

  // Debugging: Log updated formData
  useEffect(() => {
    getAssignedConsignments();
    const count = Object?.values(filterData)?.filter(
      (val) => val && val.length !== 0,
    )?.length;
    setFilterCount(count);
  }, [filterData, currentPage, pageSize, activeTab]);

  //  useEffect(() => {
  //    if (customFields.length && selectedCustomColumns.length === 0) {
  //      setSelectedCustomColumns(customFields.map(f => f.CFID));
  //    }
  //  }, [customFields]);

  //create consign form
  const BulkCreateForm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);

    const staticFields = [
      [
        {
          id: 1,
          label: "Consignor",
          type: "selectwithvalue",
          name: "consignor",
          // Consignor is stored/updated as a geofence id (see consignorName
          // resolution in handleSubmitForm), so options must come from the
          // same consignorFenceList, not the entity-id based consignerList.
          options: consignorFenceList?.map((item) => ({
            label: item.name,
            value: String(item.geofence_id),
          })),
          placeholder: "Consignor",
          style: "",
          validationRules: [
            { required: true, message: "Consignor is required" },
          ],
        },
        {
          id: 2,
          label: "Transporter",
          type: "selectwithvalue",
          name: "transporter",
          options:
            userInfo?.MCID === 71
              ? transporterList
                  ?.filter((item) => item.ID === 14046)
                  .map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))
              : userInfo?.MCID === 46
                ? transporterList
                    ?.filter((item) => item.ID === 32922)
                    .map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))
                : transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  })),
          placeholder: "Transporter",
          style: "",
          disabled: userInfo?.MCID === 71 || userInfo?.MCID === 46,
          validationRules: [
            { required: true, message: "Transporter is required" },
          ],
          initialValue:
            userInfo?.MCID === 71
              ? 14046
              : userInfo?.MCID === 46
                ? 32922
                : undefined,
        },

        // {
        //   id: 3,
        //   label: "Consignee",
        //   type: "selectwithvalue",
        //   name: "consignee",
        //   options: consigneeList?.map((item) => ({
        //     label: item.Name,
        //     value: item.ID,
        //   })),
        //   placeholder: "TQS Agency",
        //   style: "",
        //   validationRules: [
        //     { required: true, message: "Consignee is required" },
        //   ],
        // },
        {
          id: 3,
          label: "Consignee",
          // Consignee is a multi-fence list, stored as an array of
          // { index: geofence_id } entries (see handleEdit), so it needs the
          // multi-select "addfence" type, not a single "selectwithvalue".
          type: "addfence",
          name: "fence",
          options: consigneeFenceList?.map((item) => ({
            label: item.name,
            value: String(item.geofence_id),
          })),
          placeholder: "TQS Agency",
          style: "",
          validationRules: [
            { required: true, message: "Consignee is required" },
          ],
        },
        {
          id: 4,
          label: "Charge Type",
          type: "selectwithvalue",
          name: "chargetype",
          options:
            userInfo?.MCID === 46
              ? chargetype
                  ?.filter((item) => item.value === 6)
                  .map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))
              : userInfo?.MCID === 72
                ? chargetype
                    ?.filter((item) => item.value === 3)
                    .map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))
                : chargetype?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  })),
          disabled: userInfo?.MCID === 46 || userInfo?.MCID === 72,
          style: "",
          validationRules: [
            { required: false, message: "Charge Type is required" },
          ],
          initialValue: userInfo?.MCID === 46 ? 6 : undefined,
        },
      ],

      [
        // {
        //   id: 5,
        //   label: "Priority",
        //   type: "selectwithvalue",
        //   name: "priority",
        //   options: priorityType?.map((item) => ({
        //     label: item.name,
        //     value: item.value,
        //   })),
        //   placeholder: "High",
        //   style: "",
        //   validationRules: [
        //     { required: true, message: "Priority is required" },
        //   ],
        // },
        {
          id: 6,
          label: "Number of Deliverables",
          type: "number",
          name: "noofdeliverables",
          placeholder: "200",
          style: "",
          validationRules: [
            { required: false, message: "Number of Deliverables is required" },
          ],
        },
        {
          id: 7,
          label: (
            <span
              style={{
                color: "black",
                fontSize:
                  window.innerWidth >= 320 && window.innerWidth <= 426
                    ? "12px"
                    : "14px",
              }}
            >
              {window.innerWidth >= 320 && window.innerWidth <= 426
                ? "Single Deliverable (in cm)"
                : "Dimension of single deliverable (in cm)"}
            </span>
          ),
          type: "text",
          name: "dimension",
          placeholder: "200",
          style: "",
          validationRules: [
            {
              required: false,
              message: "Dimension of single deliverable is required",
            },
          ],
        },
        {
          id: 8,
          label: "Gross Weight (in Kg)",
          type: "text",
          name: "gross",
          placeholder: "200",
          style: "",
        },
      ],
      [
        {
          id: 9,
          label: "Delivery Pin",
          type: "switch",
          name: "switch",
        },
        {
          id: 10,

          label:
            window.innerWidth >= 320 && window.innerWidth <= 426
              ? "Pickup Date & Time"
              : "Pickup Date & Time",
          type: "date",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          name: "pdate",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.pdate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Pickup Date & Time is required" },
          ],
        },
        {
          id: 11,
          label: "Dropoff Date & Time",
          type: "date",
          name: "ddate",
          showtime: true,
          format: "YYYY-MM-DD HH:mm:ss",
          placeholder: "24th Aug 2024; 07:10 AM",
          value: "formData.ddate",
          maxLength: 50,
          onChange: "",
          style: "",
          validationRules: [
            { required: true, message: "Dropoff Date Time is required" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const pickup = getFieldValue("pdate");
                if (!value || !pickup) return Promise.resolve();

                if (dayjs(value).isAfter(dayjs(pickup))) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    "Drop-off Date & Time must be later than Pick-up Date & Time.",
                  ),
                );
              },
            }),
          ],
        },
        {},
      ],
      // [
      //   {
      //     id: 13,
      //     label: "Dispatch Type",
      //     type: "selectwithvalue",
      //     name: "dispatchtype",
      //     options: DispatchType?.map((item) => ({
      //       label: item?.name,
      //       value: item?.value,
      //     })),
      //     placeholder: "Regular",
      //     style: "",
      //     validationRules: [
      //       { required: true, message: "Dispatch Type is required" },
      //     ],
      //   },
      //   {
      //     id: 14,
      //     label: "Shippment Type",
      //     type: "selectwithvalue",
      //     name: "shipmenttype",
      //     options: shipmentType?.map((item) => ({
      //       label: item?.name,
      //       value: item?.value,
      //     })),
      //     placeholder: "Delivery",
      //     style: "",
      //     validationRules: [
      //       { required: true, message: "ShipmentType Type is required" },
      //     ],
      //   },
      //   {
      //     id: 15,
      //     label: "Finished Type",
      //     type: "selectwithvalue",
      //     name: "finishtype",
      //     options: FinishType?.map((item) => ({
      //       label: item.name,
      //       value: item.value,
      //     })),
      //     placeholder: "Select Finished Type",
      //     style: {},
      //     validationRules: [
      //       { required: true, message: "Finished Type is required" },
      //     ],
      //   },
      //   {
      //     id: 16,
      //     label: "Delivery No",
      //     type: "text",
      //     name: "deliveryno",
      //     placeholder: "",
      //     style: "",
      //     validationRules: [
      //       { required: true, message: "Delivery Number is required" },
      //     ],
      //   },
      // ],
      [
        {
          id: 13,
          label: "Pickup Notes",
          type: "text",
          name: "pickupnotes",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Priority is required" },
          ],
        },
        {
          id: 14,
          label: "Dropoff Notes",
          type: "text",
          name: "dropoffnotes",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Dropoff Notes is required" },
          ],
        },
        {
          id: 15,
          label: "Remarks",
          type: "text",
          name: "remark",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Remarks is required" },
          ],
        },
        {
          id: 16,
          label: "Zone",
          type: "text",
          name: "Zone",
          placeholder: "",
          style: "",
          validationRules: [{ required: false, message: "Zone is required" }],
        },
      ],
      [
        {
          id: 17,
          label: "Link Dossier",
          type: "text",
          name: "linkdossier",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Link Dossier is required" },
          ],
        },
        {
          id: 18,
          label: "Reference No",
          type: "text",
          name: "ReferenceNo",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Reference No is required" },
          ],
        },
        {
          id: 19,
          label: "Container No",
          type: "text",
          name: "ContainerNo",
          placeholder: "",
          style: "",
          validationRules: [
            { required: false, message: "Container No is required" },
          ],
        },
        {},
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);

  const AssignModal = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle-Driver</span>,
              type: "select",
              name: "driver",
              placeholder: "KA2313- Dev Edward",
              maxLength: 50,
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Trip Code</span>,
              type: "select",
              name: "tripcode",
              placeholder: "9123",
              maxLength: 50,
            },
          ],
        ],
      },
    ],
  };

  const locationClick = (name) => {
    setSelectedItem(name);
    setLocationModal(true);
  };

  const handleclick = (record) => {
    setConsignee(true);
    setConsignmentDetails(record);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const dbId = dbIdByTripId[id] || id;
      const result = await deleteDbConsignment(dbId);

      if (result.ok) {
        await CustomeDataDelete(reftab, id);
        message.success("Trip deleted successfully");
      } else {
        message.error(
          result.data?.message ||
            result.data?.Message ||
            "Failed to delete trip",
        );
      }
    } catch (error) {
      console.error("[handleDelete] error -->", error);
      message.error("An error occurred while deleting the trip.");
    } finally {
      setConsignee(false);
      getAssignedConsignments();
      refreshDbIdMap();
      setLoading(false);
    }
  };

  const handleEditTripChange = (e) => {
    const { value, name } = e.target;
    setEditingTripData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditTripSelectChange = async (
    value,
    field,
    fields,
    index = 0,
  ) => {
    if (fields === "list") {
      setEditingTripData((prev) => {
        let updated = Array.isArray(prev.fence) ? [...prev.fence] : [];
        if (updated.length <= index) updated[index] = {};
        updated[index] = { ...updated[index], [field]: value };
        return { ...prev, fence: updated };
      });
    } else if (field === "vehicle") {
      const selected = vehicleOptionss.find(
        (v) => String(v.value) === String(value),
      );
      let device = selected?.device_imei || "";
      if (!device && value) {
        try {
          const devResp = await fetchNexusAssetInfo(value);
          device =
            devResp?.response?.device_name ||
            devResp?.response?.device_imei ||
            devResp?.response?.device_id ||
            "";
        } catch (err) {}
      }
      editTripForm.setFieldsValue({ vehicle: value, device });
      setEditingTripData((prev) => ({ ...prev, vehicle: value, device }));
    } else {
      setEditingTripData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleUpdateTrip = async (values) => {
    setLoading(true);
    try {
      const selectedVehicle = vehicleOptionss.find(
        (v) => String(v.value) === String(editingTripData.vehicle),
      );
      // the vehicle's name, never its id: when the list does not have it, keep the
      // name the trip already had
      const vehRegNo =
        selectedVehicle?.label ||
        editingTripData.vehicleLabel ||
        (/^\d+$/.test(String(editingTripData.vehicle ?? "")) ? "" : editingTripData.vehicle);

      const fenceArray = Array.isArray(editingTripData.fence)
        ? editingTripData.fence
        : editingTripData.fence
          ? [editingTripData.fence]
          : [];
      const consigneeIds = fenceArray
        .map((f) => {
          const val = typeof f === "object" ? Object.values(f)[0] : f;
          if (!val) return null;
          const found =
            fenceList?.find(
              (item) =>
                String(item.name) === String(val) ||
                String(item.geofence_id) === String(val),
            ) ||
            consigneeFenceList?.find(
              (item) =>
                String(item.name) === String(val) ||
                String(item.geofence_id) === String(val),
            );
          return found ? (found.geofence_id ?? found.id ?? val) : val;
        })
        .filter(Boolean);

      // Resolve consignor/consignee ids to display names, same as the create path,
      // so the update payload doesn't leave the backend's name fields as raw ids.
      const findFenceNameForTrip = (list, id) =>
        list?.find((f) => String(f.geofence_id) === String(id))?.name;
      const consignorName =
        findFenceNameForTrip(consignorFenceList, editingTripData.consignor) ||
        findFenceNameForTrip(fenceList, editingTripData.consignor) ||
        "";
      const consigneeNames = {};
      consigneeIds.forEach((fenceId) => {
        const name =
          findFenceNameForTrip(consigneeFenceList, fenceId) ||
          findFenceNameForTrip(fenceList, fenceId);
        if (name) consigneeNames[fenceId] = name;
      });

      const tripId =
        editingTripData.trip_id ??
        editingTripData.tripid ??
        editingTripData.TripId ??
        editingTripData.id;
      const dbId =
        dbIdByTripId[tripId] ??
        editingTripData.consignid ??
        editingTripData.ConsignId ??
        editingTripData.id ??
        tripId;

      const formattedPickup =
        editingTripData.pdate && dayjs(editingTripData.pdate).isValid()
          ? dayjs(editingTripData.pdate).format("YYYY-MM-DD HH:mm:ss")
          : null;
      const formattedDrop =
        editingTripData.ddate && dayjs(editingTripData.ddate).isValid()
          ? dayjs(editingTripData.ddate).format("YYYY-MM-DD HH:mm:ss")
          : null;

      const payload = {
        consignid: dbId,
        consignId: dbId,
        id: dbId,
        tripid: tripId,
        tripId: tripId,
        vehid: editingTripData.vehicle,
        vehId: editingTripData.vehicle,
        vehiclename: vehRegNo,
        drivername: editingTripData.driver_name || "Unassigned",
        consigner: editingTripData.consignor,
        consignor: editingTripData.consignor,
        consignorName,
        consignee: consigneeIds,
        consigneeNames,
        companyid: editingTripData.company,
        companyId: editingTripData.company,
        pickuptime: formattedPickup,
        pickupTime: formattedPickup,
        droptime: formattedDrop,
        dropTime: formattedDrop,
        dispatchType: editingTripData.dispatchtype ?? "0",
        dispatchtype: editingTripData.dispatchtype ?? "0",
        completionType: editingTripData.finishtype,
        completiontype: editingTripData.finishtype,
        deviceid: editingTripData.device,
        deviceId: editingTripData.device,
        deliveryNo: editingTripData.deliveryNo,
        deliveryno: editingTripData.deliveryNo,
        crby: userInfo?.UID,
        isActive: true,
        container: editingTripData.containerno || "",
        declaration_no: editingTripData.declarationNo || "",
        goods_description: editingTripData.remark || "",
        asset_type: selectedVehicle?.asset_type || "",
      };

      const result = await updateDbConsignment(payload);

      if (result.ok) {
        message.success("Trip updated successfully");
        setEditTripDrawerOpen(false);
        setEditingTripData({});
        editTripForm.resetFields();
        getAssignedConsignments();
        refreshDbIdMap();
      } else {
        message.error(
          result.data?.message ||
            result.data?.Message ||
            "Failed to update trip",
        );
      }
    } catch (error) {
      console.error("[handleUpdateTrip] error -->", error);
      message.error("An error occurred while updating the trip.");
    } finally {
      setLoading(false);
    }
  };

  const handleBulkDelete = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `ai/bulkDeleteAIConsignment`, {
      consignIds: selectedRowKeys,
    });

    for (const id of selectedRowKeys) {
      await CustomeDataDelete(reftab, id);
    }
    setConsignee(false);
    GetAllCustomeData(reftab);
    getAssignedConsignments();
    setIsBulkDeleteModalVisible(false);

    setLoading(false);
    message.success("Consignments Deleted Successfully");
  };

  const getsingleConsigneeData = async (id) => {
    try {
      const { data } = await CALL_API("GET", `entity/getbyId?id=${id}`);
      return data;
    } catch (error) {
      console.error("Error fetching consignee data:", error);
      return null;
    }
  };
  //Bulk create API Calling Function

  const bulkSubmit = async (values) => {
    setLoading(true);
    try {
      const selectedVehicle = vehicleOptionss.find(
        (v) => String(v.value) === String(values.vehicle),
      );
      const vehRegNo = selectedVehicle?.label || "";

      const fenceArray = Array.isArray(formData.fence)
        ? formData.fence
        : formData.fence
          ? [formData.fence]
          : [];
      const cleanFenceArray = fenceArray.map((f) => Object.values(f)[0]);

      // geofence_id → name, keyed by consignee id (stored per consignment row)
      const findFenceName = (list, id) =>
        list?.find((f) => String(f.geofence_id) === String(id))?.name;
      const consigneeNames = {};
      cleanFenceArray.forEach((fenceId) => {
        const name =
          findFenceName(consigneeFenceList, fenceId) ||
          findFenceName(fenceList, fenceId);
        if (name) consigneeNames[fenceId] = name;
      });

      // Resolve consignor name from consignorFenceList using formData.consignor (geofence_id)
      const consignorName =
        findFenceName(consignorFenceList, formData?.consignor) ||
        findFenceName(fenceList, formData?.consignor) ||
        "";

      // Vehicle name, device and driver from the Asset API
      let assetName = vehRegNo;
      let deviceId = selectedVehicle?.device_imei || "";
      let driverId = null;
      let driverName = null;
      if (formData?.vehicle) {
        try {
          const [infoResp, allResp] = await Promise.all([
            fetchNexusAssetInfo(formData.vehicle),
            fetchNexusAssets(formData?.company),
          ]);
          const info = infoResp?.response || {};
          const asset = Array.isArray(allResp?.response)
            ? allResp.response.find(
                (a) => String(a.asset_id) === String(formData.vehicle),
              )
            : null;
          assetName = info.asset_name || asset?.asset_name || assetName;
          deviceId = info.imei || asset?.device_imei || deviceId;
          driverId = asset?.master_driver_id ?? null;
          driverName =
            asset?.driver_name ||
            asset?.master_driver_name ||
            info.driver_name ||
            null;
        } catch (err) {
          console.error("[bulkSubmit] Asset API error:", err);
        }
      }

      // a driver picked in the form wins over the vehicle's default driver
      // (a typed name that is not one of the company's drivers is saved as typed)
      const typedDriver = String(formData?.driver ?? "").trim();
      if (typedDriver) {
        const chosen = driverOptions.find(
          (d) => String(d.label).trim().toLowerCase() === typedDriver.toLowerCase(),
        );
        driverId = chosen && Number.isFinite(Number(chosen.value)) ? Number(chosen.value) : null;
        driverName = chosen ? chosen.label : typedDriver;
      }

      const payload = {
        vehid: formData?.vehicle,
        vehicleName: assetName || null,
        driverId,
        driverName,
        consigner: formData?.consignor,
        consignorName,
        consignee: formData?.fence,
        consigneeNames,
        transporter: formData?.transporter,
        chargetype: formData?.chargetype,
        companyid: formData?.company,
        mcid: userInfo?.MCID,
        tripType: formData?.tripType,
        pickuptime: formData?.pdate,
        droptime: formData?.ddate,
        dispatchType: formData?.dispatchtype,
        shipmentType: formData?.shipmentType,
        completionType: formData?.finishtype,
        deviceId: deviceId || null,
        deliveryNo: formData?.deliveryNo,
        container: formData?.containerno || null,
        tripallowance: formData?.tripallowance ?? null,
      };

      const created = await createDbConsignment(payload);
      if (!created?.ok) {
        // e.g. a Regular Dispatch on a vehicle that already has an ongoing trip
        message.error(
          created?.data?.data ||
            created?.data?.message ||
            created?.data?.Message ||
            "Unable to create the trip",
        );
        return;
      }
      await refreshDbIdMap();

      message.success("Trip created successfully");
      handleCancel();
      getAssignedConsignments();
      setDrawerOpen(false);
    } catch (error) {
      console.error("[bulkSubmit] Error -->", error);
      message.error("Error occurred while creating trip");
    } finally {
      setLoading(false);
    }
  };
  //Consignment Create and Update API CALLING function
  const handleSubmitForm = async (values) => {
    try {
      setLoading(true);

      if (isEdit) {
        // Edit path (detail panel "Edit") -> nexus/updateconsign
        const rawTrip = consignmentDetails?.rawTrip || {};
        const consigneeArr = Array.isArray(formData?.fence)
          ? formData.fence
              .map((f) => (typeof f === "object" ? Object.values(f)[0] : f))
              .filter(Boolean)
          : rawTrip.consignee || [];

        // Resolve consignor/consignee ids to display names, same as the create path,
        // so the update payload doesn't leave the backend's name fields as raw ids.
        const findFenceName = (list, id) =>
          list?.find((f) => String(f.geofence_id) === String(id))?.name;
        const consignorName =
          findFenceName(
            consignorFenceList,
            formData?.consignor ?? rawTrip.consigner,
          ) ||
          findFenceName(fenceList, formData?.consignor ?? rawTrip.consigner) ||
          rawTrip.consignorName ||
          "";
        const consigneeNames = {};
        consigneeArr.forEach((fenceId) => {
          const name =
            findFenceName(consigneeFenceList, fenceId) ||
            findFenceName(fenceList, fenceId);
          if (name) consigneeNames[fenceId] = name;
        });

        const dbUpdatePayload = {
          consignid: formData?.ConsignId ?? rawTrip.consignid,
          code: rawTrip.code,
          tripid: formData?.TripId ?? rawTrip.tripid,
          vehid: rawTrip.vehid,
          driverId: rawTrip.driverId,
          status: rawTrip.status,
          consigner: formData?.consignor ?? rawTrip.consigner,
          consignorName,
          consignee: consigneeArr,
          consigneeNames,
          transporter: formData?.transporter ?? rawTrip.transporter,
          chargetype: formData?.chargetype ?? rawTrip.chargetype,
          companyid: rawTrip.companyid ?? userInfo?.MCID,
          tripType: rawTrip.tripType,
          pickupTime: formData?.pdate
            ? dayjs(formData.pdate).toISOString()
            : rawTrip.pickupTime,
          dropTime: formData?.ddate
            ? dayjs(formData.ddate).toISOString()
            : rawTrip.dropTime,
          dispatchType: rawTrip.dispatchType,
          shipmentType: rawTrip.shipmentType,
          completionType: rawTrip.completionType,
          deviceid: rawTrip.deviceid,
          deliveryNo: formData?.ReferenceNo ?? rawTrip.deliveryNo,
          // only consignments with a vehicle have a trip to hold the allowance
          ...(rawTrip.vehid && formData?.tripallowance !== undefined
            ? { tripallowance: formData.tripallowance }
            : {}),
        };

        const data = await updateDbConsignment(dbUpdatePayload);

        const ConsignId = formData?.ConsignId;
        if (ConsignId) {
          await CustomeDataUpdate(reftab, ConsignId, values);
        } else {
          console.error("ConsignId not found for update:", data);
        }

        await GetAllCustomeData(reftab);
        await getAssignedConsignments();
        await refreshDbIdMap();
        handleCancel();
        message.success("Consignment updated successfully");
        setLoading(false);
        return;
      }

      // Create path
      const selectedFence = fenceList.find(
        (f) =>
          String(f.FGUID) === String(formData?.fence) ||
          String(f.FName) === String(formData?.fence),
      );
      const payload = {
        ChargeType: formData?.chargetype,
        Cust: formData?.consignor,
        DropOffDateTime: formData?.ddate
          ? dayjs(formData.ddate).toISOString()
          : undefined,
        DropOffNote: formData?.dropoffnotes || "",
        GrossVolume: Number(formData?.gross) || 0,
        GrossWeight: Number(formData?.gross) || 0,
        ISDELOTP: formData?.switch,
        PickUpDateTime: formData?.pdate
          ? dayjs(formData.pdate).toISOString()
          : undefined,
        PickUpNote: formData?.pickupnotes,
        Priority: 1,
        Receiver: null,
        FID: formData?.fence || selectedFence?.FGUID,
        FName: selectedFence?.FName,
        Remarks: formData?.remark,
        Shipper: formData?.transporter,
        StartLat: Number(
          formData?.plocationname?.latitude ?? formData?.StartLat,
        ),
        StartLng: Number(
          formData?.plocationname?.longitude ?? formData?.StartLng,
        ),
        EndLocation: selectedFence?.FAddress || "",
        EndLat: Number(selectedFence?.FCenterLat) || 0,
        EndLng: Number(selectedFence?.FCenterLon) || 0,
        StartLocation: formData?.plocationname?.place_name,
        McId: userInfo?.MCID,
        dimension: formData?.dimension || "",
        noOfDeliverables: formData?.noofdeliverables || 0,
        FWayBill: formData?.deliveryNo || "",
        ReferenceNo: formData?.ReferenceNo,
        ContainerNo: formData?.ContainerNo || formData?.containerno,
        TripId: null,
        CrBy: userInfo?.UID,
      };

      const { data } = await CALL_API("POST", `ai/consignment/create`, payload);

      const ConsignId =
        data?.ConsignId || data?.CONSIGNID || data?.result?.CONSIGNID;

      if (ConsignId) {
        await CustomeDataCreate(reftab, ConsignId, values);
      } else {
        console.error("ConsignId not found in API response:", data);
      }
      await GetAllCustomeData(reftab);
      await getAssignedConsignments();
      handleCancel();
      message.success("Consignment created successfully");
      setLoading(false);
    } catch (error) {
      console.error("[handleSubmitForm] error -->", error);
      setLoading(false);
    }
  };

  const [checkedList, setCheckedList] = useState([]);

  const onCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setSortFields(isChecked ? allOptions : []);
  };

  const allOptions = [
    "Transporterrr",
    "Order No",
    "consignorrr",
    "consignee",
    "ReferenceNo",
    "FWayBill",
  ];

  const handleSortOptionsChange = (checkedValues) => {
    setSortFields(checkedValues);
  };

  const content = (
    <WrapperBox>
      <div className="checkbox_group_container">
        <Checkbox
          indeterminate={
            sortFields.length > 0 && sortFields.length < allOptions.length
          }
          onChange={onCheckAllChange}
          checked={sortFields.length === allOptions.length}
        >
          All
        </Checkbox>

        <Checkbox.Group value={sortFields} onChange={handleSortOptionsChange}>
          <div className="checkbox_group_container">
            <Checkbox value="consignorrr">Consignor</Checkbox>
            <Checkbox value="consignee">Consignee</Checkbox>
            <Checkbox value="Transporterrr">Transporter</Checkbox>
            <Checkbox value="Order No">Order No</Checkbox>

            {userInfo?.MCID === 72 && (
              <>
                <Checkbox value="ReferenceNo">Reference No</Checkbox>
                <Checkbox value="FWayBill">Delivery Note Number</Checkbox>
              </>
            )}
          </div>
        </Checkbox.Group>
      </div>
    </WrapperBox>
  );
  const handleCopyClick = async () => {
    setNewLoading(true);
    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "aiconsignment/copy",
        {
          consignId: copyId,
          MCID: userInfo?.MCID,
        },
      );
      if (ResponseCode !== 200) {
        message.error("Something went wrong. Please try again later!");
      } else {
        message.success("Consignment duplicated successfully");
      }
      setIsConformationModal(false);
      setCopyId(null);
      getAssignedConsignments();
      setNewLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };
  const [width, setWidth] = useState(window.innerWidth);
  const [status, setStatus] = useState("Assigned");
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChangeformobile = (value) => {
    setStatus(value);

    if (value === "Assigned") {
      setActiveTab("label1");
    } else if (value === "Unassigned") {
      setActiveTab("label2");
    }
  };

  const [widdth, setWiddth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWiddth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <UIModal
        width={1200}
        open={showModal}
        onClose={handlecancelmodal}
        closeButton={false}
        size="lg"
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <span className="flilter_five">Filters ({filterCount})</span>
                  {/* <span
                     style={{
                       color: "#2C963D",
                       fontWeight: "400",
                       fontSize: "20px",
                     }}
                   >
                     5 Results Found
                   </span> */}
                </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <ButtonFilled onClick={editModuleupdate}>Clear All</ButtonFilled>
          </div>
        }
      >
        {/* This is the BODY section of the Modal */}
        <WrapperBox>
          <GridBuilder
            formStructureJson={ModalForm}
            handleChange={handleFilterChange}
            formSubmit={handleSubmitForm}
            initialValues={filterData}
            handleSelectChange={handleFilterSelectChange}
            form={filterform}
            twoPerRowInMobile={true} // <-- this enables 2 fields per row in mobile
          />
        </WrapperBox>
      </UIModal>
      <UIModal
        width={700}
        open={isConformationModal}
        onClose={() => {
          setIsConformationModal(false);
          setCopyId(null);
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to duplicate this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled loading={newLoading} onClick={handleCopyClick}>
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsConformationModal(false);
                setCopyId(null);
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>"You want to mark this trip as invalid?"</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={() => {
                handleDelete(deleteId); // Call the delete function with the selected ID
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>

      {consignee ? (
        <>
          <WrapperBox>
            <NexusConsignDetails
              consignmentDetails={consignmentDetails}
              setConsignee={setConsignee}
              setDrawerOpen={setDrawerOpen}
              setFormData={setFormData}
              setIsEdit={setIsEdit}
              handleDelete={handleDelete}
            />
          </WrapperBox>
        </>
      ) : (
        <>
          <WrapperBox>
            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <Row gutter={16}>
                  <Col xs={24} xl={24}>
                    <div className="container_for_assigned_unassigned">
                      <div>
                        {width >= 320 && width <= 426 ? (
                          <div className="mobile_section">
                            <Select
                              className="selectdropdown_responsive"
                              value={status}
                              onChange={(value) => handleChangeformobile(value)}
                              style={{
                                width: 250,
                                borderRadius: 8,
                              }}
                              dropdownStyle={{
                                backgroundColor: "white",
                                borderRadius: 8,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              }}
                              bordered={false}
                              popupClassName="custom-dropdown"
                            >
                              <Option value="Assigned">Assigned</Option>
                              <Option value="Unassigned">Unassigned</Option>
                            </Select>
                          </div>
                        ) : (
                          <div></div>
                        )}

                        {width >= 320 && width <= 426 ? null : (
                          <Tab
                            defaultActiveKey={activeTab}
                            items={[
                              { key: "label1", label: "Assigned" },
                              { key: "label2", label: "Unassigned" },
                            ]}
                            onChange={handleTabChange}
                          />
                        )}
                      </div>
                      <div>
                        <div className="consingment_container">
                          <div className="consingment_container_two  responsive_containerone">
                            {width >= 320 && width <= 426 ? null : (
                              <>
                                <div className="Custom">
                                  <Tooltip
                                    title="Export"
                                    placement="bottom"
                                    visible={visibleExport}
                                    onVisibleChange={
                                      handleTooltipVisibleChangeExport
                                    }
                                    overlayInnerStyle={{
                                      backgroundColor: "transparent",
                                      color: "#5f6d8c",
                                      boxShadow: "none",
                                      padding: "0",
                                    }}
                                  >
                                    <Spin spinning={CSVLoader}>
                                      <img
                                        src={ExportIcon}
                                        alt="Export"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          cursor: exportAllowed
                                            ? "pointer"
                                            : "not-allowed",
                                          marginRight: "40px",
                                          backgroundColor: "#EBF7ED",
                                          borderRadius: "6px",
                                        }}
                                        onClick={() => {
                                          if (!exportAllowed) return;
                                          prepareCSV();
                                        }}
                                      />
                                    </Spin>
                                    <CSVLink
                                      data={CSVList}
                                      filename={"Consignment.csv"}
                                      asyncOnClick={true}
                                      ref={csvLinkEl}
                                    />
                                  </Tooltip>
                                </div>
                              </>
                            )}
                            {width >= 320 && width <= 426 ? null : (
                              <div className="Custom">
                                <Tooltip
                                  title={
                                    !importAllowed ? "No permission" : "Import"
                                  }
                                  placement="bottom"
                                  visible={visibleImport}
                                  onVisibleChange={
                                    handleTooltipVisibleChangeImport
                                  }
                                  overlayInnerStyle={{
                                    backgroundColor: "transparent",
                                    color: "#5f6d8c",
                                    boxShadow: "none",
                                    padding: "0",
                                  }}
                                >
                                  <Upload
                                    beforeUpload={handleUpload}
                                    showUploadList={false}
                                    accept=".csv"
                                  >
                                    <img
                                      src={ImportIcon}
                                      alt="Import"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        cursor: importAllowed
                                          ? "pointer"
                                          : "not-allowed",
                                        marginRight: "40px",
                                        backgroundColor: "#EBF7ED",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  </Upload>
                                </Tooltip>
                              </div>
                            )}
                            <Badge
                              count={filterCount}
                              className="badg"
                              style={{ marginRight: "20px" }}
                            >
                              <Avatar
                                shape="circle"
                                size="small"
                                src={FilterIcon}
                                className="filterstyle"
                                onClick={handleclickme}
                                style={{ marginRight: "20px" }}
                              />
                            </Badge>
                            {width >= 320 && width <= 426 ? null : (
                              <div className="Custom">
                                <Tooltip
                                  title="Sort Column"
                                  placement="bottom"
                                  visible={visibleSort}
                                  onVisibleChange={
                                    handleTooltipVisibleChangeSort
                                  }
                                  overlayInnerStyle={{
                                    backgroundColor: "transparent",
                                    color: "#5f6d8c",
                                    boxShadow: "none",
                                    padding: "0",
                                  }}
                                >
                                  <Popover content={content} trigger="click">
                                    <img
                                      src={SortIcon}
                                      alt="Sort"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        cursor: "pointer",
                                        marginRight: "30px",
                                        backgroundColor: "#EBF7ED",
                                        borderRadius: "6px",
                                      }}
                                      onClick={(e) => e.preventDefault()}
                                    />
                                  </Popover>
                                </Tooltip>
                              </div>
                            )}
                            <Tooltip
                              title={!createAllowed ? "No permission" : ""}
                            ></Tooltip>
                            <Tooltip
                              title={!createAllowed ? "No permission" : ""}
                            >
                              <ButtonOutlined
                                style={{
                                  cursor: createAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={() => {
                                  if (!createAllowed) return;
                                  handleBulkCreateClick();
                                }}
                                className="bulk_btn"
                              >
                                + Create Single / Bulk
                              </ButtonOutlined>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <div className="consingment_container"></div>
              </Col>
            </Row>
          </WrapperBox>

          <TableStyle>
            <Row gutter={16}>
              <Col xl={24} xs={24}>
                <div className="table_wrapper_one">
                  <div className="consingment_container">
                    <p className="datsource_length">{total} Consignments</p>
                  </div>
                  <div>
                    {window.innerWidth >= 320 && window.innerWidth <= 2561 ? (
                      <>
                        {selectedRowKeys.length > 0 &&
                          activeTab === "label2" && (
                            <div
                              className=""
                              style={{
                                position: "fixed",
                                bottom: "0",
                                zIndex: "20",
                                width: "97%",
                                backgroundColor: "white",
                                maxWidth: "-webkit-fill-available",
                                overflowX: "scroll",
                              }}
                            >
                              <div
                                className="d-flex w-100 align-items-center justify-content-between gap-3 p-2 overflow-x-scroll
                              "
                              >
                                {width < 376 ? (
                                  <div className="d-flex gap-3 align-items-center">
                                    <Deleteunassigned
                                      style={{
                                        cursor: "pointer",
                                        alignSelf: "center",
                                        paddingLeft: "10px",
                                        width: "50px",
                                        height: "50px",
                                      }}
                                      // onClick={() => setIsBulkDeleteModalVisible(true)      }
                                      onClick={() =>
                                        setIsBulkDeleteModalVisible(true)
                                      }
                                    />
                                    <Buttontransparent
                                      className="footer-btn text-danger "
                                      style={{ fontSize: "13px" }}
                                      onClick={() => {
                                        setSelectedRowKeys([]);
                                        setSelectedRows([]);
                                      }}
                                    >
                                      Cancel
                                    </Buttontransparent>
                                    {/* <Tooltip
                                      title={
                                        !addTripAllowed ? "No permission" : ""
                                      }
                                    >
                                      <Button
                                        className="footer-btn footer_assigntrip"
                                        style={{
                                          color: "#fff",
                                          fontSize: "13px",
                                        }}
                                        onClick={() => {
                                          if (!addTripAllowed) return;
                                          setAssignModal(true);
                                        }}
                                      >
                                        + Add To Trip
                                      </Button>
                                    </Tooltip> */}
                                    <Tooltip
                                      title={
                                        !assignAllowed ? "No permission" : ""
                                      }
                                    >
                                      <Button
                                        className="footer-btn bg-success"
                                        style={{
                                          color: "#fff",
                                          fontSize: "13px",
                                        }}
                                        onClick={() => {
                                          if (!assignAllowed) return;
                                          if (selectedRows.length > 0) {
                                            const firstRow = selectedRows[0];

                                            tripform.setFieldsValue({
                                              pdate: firstRow.PickUpDateTime
                                                ? dayjs(
                                                    firstRow.PickUpDateTime,
                                                  ).local()
                                                : null,

                                              ddate: firstRow.DropOffDateTime
                                                ? dayjs(
                                                    firstRow.DropOffDateTime,
                                                  ).local()
                                                : null,
                                            });
                                          }

                                          setIsCreateTrip(true);
                                        }}
                                      >
                                        Assign Trip
                                      </Button>
                                    </Tooltip>
                                  </div>
                                ) : (
                                  <>
                                    <div className="container_six">
                                      <Deleteunassigned
                                        style={{
                                          cursor: "pointer",
                                          alignSelf: "center",
                                          paddingLeft: "10px",
                                          width: "50px",
                                          height: "50px",
                                        }}
                                        // onClick={() => setIsBulkDeleteModalVisible(true)      }
                                        onClick={() =>
                                          setIsBulkDeleteModalVisible(true)
                                        }
                                      />
                                      <div className="d-flex gap-3">
                                        <Button
                                          className="footer-btn text-danger "
                                          style={{ fontSize: "13px" }}
                                          onClick={() => {
                                            setSelectedRowKeys([]);
                                            setSelectedRows([]);
                                          }}
                                        >
                                          Cancel
                                        </Button>
                                        {/* <Button
                                          className="footer-btn footer_assigntrip"
                                          style={{
                                            color: "#fff",
                                            fontSize: "13px",
                                          }}
                                          onClick={() => setAssignModal(true)}
                                        >
                                          + Add To Trip
                                        </Button> */}
                                        <Button
                                          className="footer-btn bg-success"
                                          style={{
                                            color: "#fff",
                                            fontSize: "13px",
                                          }}
                                          onClick={() => {
                                            if (selectedRows.length > 0) {
                                              const firstRow = selectedRows[0];
                                              tripform.setFieldsValue({
                                                pdate: firstRow.PickUpDateTime
                                                  ? dayjs(
                                                      firstRow.PickUpDateTime,
                                                    ).local()
                                                  : null,

                                                ddate: firstRow.DropOffDateTime
                                                  ? dayjs(
                                                      firstRow.DropOffDateTime,
                                                    ).local()
                                                  : null,
                                              });
                                            }

                                            setIsCreateTrip(true);
                                          }}
                                        >
                                          Assign Trip
                                        </Button>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div style={{ marginBottom: "55px" }}>
                    <Spin spinning={loading}>
                      <StyledTable
                        className=""
                        pagination={false}
                        dataSource={assignedConsignments}
                        columns={
                          activeTab === "label2"
                            ? columnsForUnassigned
                            : columnsForAssigned
                        }
                        rowSelection={
                          activeTab === "label2" ? rowSelection : null
                        }
                        rowKey="ConsignId"
                        onRow={(record) => ({
                          onMouseEnter: () => handleClickme(record),
                          onMouseLeave: () => setHoveredrow(null),
                          onClick: () => {
                            handleclick(record);
                          },
                        })}
                      />

                      <ReusablePagination
                        pageSize={pageSize}
                        handlePageSizeChange={handlePageSizeChange}
                        currentPage={currentPage}
                        total={total}
                        handlePageChange={handlePageChange}
                      />
                    </Spin>
                  </div>
                </div>
              </Col>
            </Row>
          </TableStyle>
        </>
      )}
      <ReusableDrawer
        title=""
        open={drawerOpen}
        setOpen={setDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={handleCancel}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              key="create"
              type="primary"
              onClick={(e) => form.submit()}
            >
              {isEdit ? "Update" : "Create"}
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignment">
                <p>
                  {isEdit
                    ? "Modifying Consignment"
                    : "Creating Bulk Consignment"}
                </p>

                <span>
                  <CloseOutlined onClick={handleCancel} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              {isEdit ? (
                <GridBuilder
                  formStructureJson={BulkCreateForm}
                  handleChange={handleChange}
                  formSubmit={handleSubmitForm}
                  initialValues={formData}
                  form={form}
                  locationClick={locationClick}
                  handleSelectChange={handleSelectChange}
                />
              ) : (
                <GridBuilder
                  formStructureJson={AddEditFormm}
                  handleChange={handleChange}
                  formSubmit={bulkSubmit}
                  initialValues={formData}
                  form={form}
                  locationClick={locationClick}
                  handleSelectChange={handleSelectChange}
                />
              )}
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
      <UIModal
        header="Assign Trip"
        open={assignModal}
        onClose={() => {
          setAssignModal(false);
          setAssignVehicleId(null);
        }}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              onClick={() => {
                setAssignModal(false);
                setAssignVehicleId(null);
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              onClick={() => AssignedVehicle(assignVehicleId)}
            >
              Update
            </ButtonFilled>
          </div>,
        ]}
        size="550px"
        closeButton={false}
      >
        <div className="p-3">
          <Select
            placeholder="Select Vehicle"
            value={formData.office}
            onChange={(value) => setAssignVehicleId(value)}
            style={{ width: "100%" }}
            validationRules={[
              { required: true, message: "Office is required" },
            ]}
          >
            {driverWithVehicle?.map((option) => (
              <Select.Option key={option} value={option?.VEHID}>
                {`${option.REGNO}-${option?.DriverName}`}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div className="p-3">
          <Select
            placeholder="Select Trip Code"
            onChange={onTripCodeSelect}
            value={selectedTripCode}
            style={{ width: "100%" }}
          >
            {Array.isArray(codeList) &&
              codeList.map((item) => (
                <Select.Option key={item.TripId} value={item.Code}>
                  {item.Code}
                </Select.Option>
              ))}
          </Select>
        </div>
      </UIModal>
      <UIModal
        width={600}
        height={600}
        open={isconfigModalVisible}
        onClose={() => {
          setIsconfigModalVisible(false);
        }}
        closeButton={false}
        size="md"
        header={
          <div className="text-start">
            <h2>Customized Column</h2>
            <label
              style={{ marginBottom: 8, display: "block", color: "#5F6D8C" }}
            >
              Columns
            </label>
          </div>
        }
        footer={
          <div className="mt-2 w-100 d-flex justify-content-end">
            <ButtonFilled
              onClick={() => {
                setIsconfigModalVisible(false); // Close the modal
              }}
            >
              Save
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsconfigModalVisible(false); // Just close the modal
              }}
            >
              Cancel
            </Buttontransparent>
          </div>
        }
      >
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Select custom columns"
          value={selectedCustomColumns}
          onChange={setSelectedCustomColumns}
          dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
          dropdownRender={(menu) => (
            <div>
              <Checkbox.Group
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "8px 12px",
                }}
                value={selectedCustomColumns}
                onChange={setSelectedCustomColumns}
              >
                {customFieldOptions.map((option) => (
                  <Checkbox
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                  >
                    {option.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </div>
          )}
        >
          {customFieldOptions.map((option) => (
            <Select.Option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </UIModal>
      <ReusableDrawer
        title=""
        open={isCreateTrip}
        setOpen={() => setIsCreateTrip(true)}
        onClose={() => setIsCreateTrip(false)}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={() => {
                tripform.resetFields();
                setIsCreateTrip(false);
                // setModaldrawer(false);
              }}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <Spin spinning={loading}>
              <ButtonFilled
                loading={loading}
                key="create"
                type="primary"
                onClick={(e) => tripform.submit()}
              >
                Create
              </ButtonFilled>
            </Spin>
          </div>,
        ]}
      >
        <WrapperBox>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h3 style={{ margin: 0 }}>Creating a Trip</h3>
            <CloseOutlined
              onClick={() => {
                tripform.resetFields();
                setIsCreateTrip(false);
              }}
              style={{ fontSize: 20, cursor: "pointer" }}
            />
          </div>
          <hr style={{ margin: "12px 0" }} />
          <Collapse
            style={{ backgroundColor: "#EBF7ED" }}
            expandIconPosition="end"
          >
            <Panel
              header={
                <span style={{ color: "#2C963D" }}>Consignment Info</span>
              }
              key="1"
            >
              <StyledTable
                className="trip-table"
                pagination={false}
                dataSource={selectedRows}
                columns={selectedColumns}
                rowKey="ConsignId"
                style={{ backgroundColor: "#EBF7ED" }}
              />
            </Panel>
          </Collapse>
          <Form
            form={tripform}
            layout="vertical"
            className="mt-3"
            onFinish={handleTripCreate}
            initialValues={{
              shipmentType: userInfo?.MCID === 55 ? 1 : "",
              tripType: userInfo?.MCID === 55 ? 1 : "",
              finishtype:
                userInfo?.MCID === 71 ||
                userInfo?.MCID === 46 ||
                userInfo?.MCID === 55
                  ? 5
                  : "",
              dispatchtype:
                userInfo?.MCID === 46 ||
                userInfo?.MCID === 55 ||
                userInfo?.MCID === 3
                  ? "0"
                  : "",
            }}
          >
            <Row gutter={16}>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Company"
                  name="company"
                  rules={[{ required: true, message: "Please select Company" }]}
                  initialValue={userInfo?.MCID === 59 ? formData?.company : ""} // pre-fill with user's company
                >
                  <Select
                    className="w-100"
                    allowClear={false}
                    showSearch
                    loading={loading}
                    disabled={userInfo?.MCID === 46}
                    options={companyOptions}
                    onChange={(companyId) => {
                      tripform.setFieldsValue({
                        vehicle: undefined,
                        device: undefined,
                      });
                      handleCompanyChange(companyId);
                      fetchAssetsByCompany(companyId);
                    }}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Trip Type"
                  name="tripType"
                  rules={[
                    { required: true, message: "Please select Trip Type" },
                  ]}
                >
                  <Select className="w-100" showSearch allowClear>
                    {tripType.map((type) => (
                      <Option key={type.value} value={type.value}>
                        {type.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Dispatch Type"
                  name="dispatchtype"
                  rules={[
                    { required: true, message: "Please select Dispatch Type" },
                  ]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    disabled={userInfo?.MCID === 3}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {DispatchType.map((type) => (
                      <Option key={type.value} value={type.value}>
                        {type.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Shipment Type"
                  name="shipmentType"
                  rules={[
                    { required: true, message: "Please select Shipment Type" },
                  ]}
                  initialValue={
                    userInfo?.MCID === 71 || userInfo?.MCID === 46
                      ? 1
                      : undefined
                  }
                >
                  <Select
                    className="w-100"
                    showSearch
                    allowClear={userInfo?.MCID !== 71}
                    disabled={userInfo?.MCID === 71} // disable for MCID 71
                  >
                    {(userInfo?.MCID === 71
                      ? shipmentType.filter((type) => type.value === 1)
                      : shipmentType
                    ).map((type) => (
                      <Option key={type.value} value={type.value}>
                        {type.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Finished Type"
                  name="finishtype"
                  rules={[
                    { required: true, message: "Please select Finish Type" },
                  ]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    disabled={userInfo?.MCID === 71}
                  >
                    {(userInfo?.MCID === 71
                      ? FinishType.filter((type) => type.value === 5) // only show 5
                      : NexusFinishType
                    ).map((type) => {
                      return (
                        <Option key={type.value} value={type.value}>
                          {type.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Pickup Date & Time"
                  name="pdate"
                  rules={[
                    { required: true, message: "Pickup date is required" },
                  ]}
                >
                  <DatePicker
                    showTime
                    format="DD-MM-YYYY HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Dropoff Date & Time"
                  name="ddate"
                  rules={[
                    { required: true, message: "Dropoff date is required" },
                  ]}
                >
                  <DatePicker
                    showTime
                    format="DD-MM-YYYY HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                {/*
                 */}
                <Form.Item
                  label="Vehicle"
                  name="vehicle"
                  rules={[
                    { required: true, message: "Please select a vehicle" },
                  ]}
                >
                  <Select
                    className="w-100"
                    showSearch
                    allowClear
                    options={vehicleOptionss}
                    loading={vehicleLoading}
                    onChange={(assetId) => {
                      const selected = vehicleOptionss.find(
                        (v) => v.value === assetId,
                      );
                      tripform.setFieldsValue({
                        device: selected?.device_imei || undefined,
                      });
                      handleVehicleChange(assetId);
                    }}
                    optionFilterProp="label"
                    placeholder="Select Vehicle"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Devices"
                  name="device"
                  rules={[{ required: true, message: "Please select Device" }]}
                >
                  <Select
                    className="w-100"
                    disabled
                    placeholder="Auto-filled from vehicle"
                    options={vehicleOptionss
                      .filter((v) => v.device_imei)
                      .map((v) => ({
                        value: v.device_imei,
                        label: v.device_imei,
                      }))}
                    notFoundContent="No device linked to selected vehicle"
                  ></Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label="Delivery Note Number"
                  name="deliveryNo"
                  rules={[
                    { required: false, message: "Delivery no is required" },
                  ]}
                >
                  <Input placeholder="Enter text here" />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item label="Trip Allowance" name="tripallowance">
                  <Input
                    type="number"
                    style={{ width: "100%" }}
                    defaultValue={0}
                    min={0}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                {/* Fuel Quantity */}
                <Form.Item label="Fuel Quantity" name="fuelQuantity">
                  <Input type="number" placeholder="" />
                </Form.Item>
              </Col>

              <Col xs={24} md={24}>
                <Form.Item label="Remark" name="remark">
                  <Input.TextArea placeholder="" rows={4} />
                </Form.Item>
              </Col>

              {tripCustomFields.map((field) => (
                <Col xs={24} md={6} key={field.CFID}>
                  <Form.Item
                    label={field.FIELDNAME}
                    name={field.FIELDNAME.replace(/\s+/g, "_").toLowerCase()}
                    rules={
                      field.REQUIRED
                        ? [
                            {
                              required: true,
                              message: `${field.FIELDNAME} is required`,
                            },
                          ]
                        : []
                    }
                  >
                    <Input />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </WrapperBox>
      </ReusableDrawer>
      <UIModal
        width={500}
        open={isBulkDeleteModalVisible}
        onClose={() => setIsBulkDeleteModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <GeoDelete />
          <h4>Delete Consignments?</h4>
          <p>
            This action will permanently delete the selected consignments.
            <br />
            Do you want to proceed?
          </p>{" "}
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleBulkDelete} // Call the delete function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsBulkDeleteModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <ReusableDrawer
        title=""
        open={editTripDrawerOpen}
        setOpen={setEditTripDrawerOpen}
        onClose={() => {
          setEditTripDrawerOpen(false);
          setEditingTripData({});
          editTripForm.resetFields();
        }}
        closable={false}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={() => {
                setEditTripDrawerOpen(false);
                setEditingTripData({});
                editTripForm.resetFields();
              }}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              key="update"
              type="primary"
              onClick={() => editTripForm.submit()}
            >
              Update
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignment">
                <p>Modifying Consignment</p>
                <span>
                  <CloseOutlined
                    onClick={() => {
                      setEditTripDrawerOpen(false);
                      setEditingTripData({});
                      editTripForm.resetFields();
                    }}
                  />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={ModifyTripForm}
                handleChange={handleEditTripChange}
                formSubmit={handleUpdateTrip}
                initialValues={editingTripData}
                form={editTripForm}
                handleSelectChange={handleEditTripSelectChange}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
      <LocationPicker
        visible={locationModal}
        onClose={() => setLocationModal(false)}
        onSelect={handleLocationSelect}
      />
    </>
  );
};

export default NexusAI;

// Place this at the top of your file
const reverseGeocode = async (lat, lng) => {
  if (!lat || !lng) return "-";
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
    );
    const data = await response.json();
    return data.display_name || "-";
  } catch (error) {
    return "-";
  }
};
// Place this at the top of your file or in a separate file
const LocationCell = ({
  startLat,
  startLng,
  endLat,
  endLng,
  locationCache,
  setLocationCache,
  renderText,
}) => {
  const [startAddress, setStartAddress] = useState(
    locationCache[`${startLat},${startLng}`],
  );
  const [endAddress, setEndAddress] = useState(
    locationCache[`${endLat},${endLng}`],
  );

  useEffect(() => {
    const startKey = `${startLat},${startLng}`;
    const endKey = `${endLat},${endLng}`;

    if (startLat && startLng && !locationCache[startKey]) {
      reverseGeocode(startLat, startLng).then((address) => {
        setLocationCache((prev) => ({ ...prev, [startKey]: address }));
        setStartAddress(address);
      });
    }

    if (endLat && endLng && !locationCache[endKey]) {
      reverseGeocode(endLat, endLng).then((address) => {
        setLocationCache((prev) => ({ ...prev, [endKey]: address }));
        setEndAddress(address);
      });
    }
    // eslint-disable-next-line
  }, [startLat, startLng, endLat, endLng]);

  const start = startAddress || locationCache[`${startLat},${startLng}`] || "-";
  const end = endAddress || locationCache[`${endLat},${endLng}`] || "-";

  const locationText = `${end}`;

  // 👇 apply your reusable render logic
  if (renderText) {
    return renderText(locationText);
  }

  return <span>{locationText}</span>;
};
